import React from 'react';

export default function DefaultCardImage({ primaryColor }) {
  return (
    <svg
      width="225"
      height="225"
      viewBox="0 0 225 225"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5205 21.924L26.721 25.3034L16.92 37.5345L15.5205 21.924Z"
        fill="black"
      />
      <path
        d="M38.0522 28.2735L49.5273 30.5685L40.9413 43.677L38.0522 28.2735Z"
        fill={primaryColor}
      />
      <path
        d="M61.0967 32.2964L72.7517 33.2954L65.6822 47.2814L61.0967 32.2964Z"
        fill="white"
      />
      <path
        d="M84.3843 33.6105L96.0753 33.201L90.7383 47.934L84.3843 33.6105Z"
        fill="white"
      />
      <path
        d="M107.591 31.7069L119.079 29.4974L116.082 44.8784L107.591 31.7069Z"
        fill="white"
      />
      <path
        d="M129.996 26.2934L140.823 21.8699L140.913 37.5389L129.996 26.2934Z"
        fill="black"
      />
      <path
        d="M151.092 16.1505L160.578 9.30145L164.349 24.5115L151.092 16.1505Z"
        fill={primaryColor}
      />
      <path
        d="M38.0518 28.278L37.1203 29.5515L36.4993 30.402L35.7163 31.473L35.0953 32.3235L34.3168 33.39L33.6913 34.2405L32.9128 35.307L32.2918 36.1575L31.5088 37.2285L30.8878 38.079L30.1048 39.15L29.4838 40.0005L28.8043 40.9275L28.6513 39.789L28.5073 38.7405L28.3318 37.431L28.1968 36.387L28.0168 35.073L27.8773 34.029L27.6973 32.7195L27.5623 31.6755L27.3823 30.3615L27.2428 29.3175L27.0673 28.008L26.9233 26.9595L26.7163 25.398L38.0518 28.278Z"
        fill="white"
      />
      <path
        d="M37.1203 29.5515L36.4993 30.402L27.0673 28.008L26.9233 26.9595L37.1203 29.5515Z"
        fill="white"
      />
      <path
        d="M35.7162 31.473L35.0952 32.3235L27.3822 30.3615L27.2427 29.3175L35.7162 31.473Z"
        fill="white"
      />
      <path
        d="M34.317 33.39L33.6915 34.2405L27.6975 32.7195L27.5625 31.6755L34.317 33.39Z"
        fill="white"
      />
      <path
        d="M32.9129 35.307L32.2919 36.1575L28.0169 35.073L27.8774 34.029L32.9129 35.307Z"
        fill="white"
      />
      <path
        d="M31.5088 37.2285L30.8878 38.079L28.3318 37.431L28.1968 36.387L31.5088 37.2285Z"
        fill="white"
      />
      <path
        d="M30.1048 39.15L29.4838 40.0005L28.6513 39.789L28.5073 38.7405L30.1048 39.15Z"
        fill="white"
      />
      <path
        d="M61.0965 32.3009L60.3044 33.6644L59.769 34.5779L59.1029 35.721L58.572 36.63L57.9059 37.773L57.375 38.682L56.709 39.825L56.178 40.734L55.512 41.8815L54.981 42.7905L54.315 43.9335L53.784 44.8425L53.2035 45.837L52.9335 44.721L52.686 43.695L52.3755 42.408L52.128 41.3865L51.8175 40.0995L51.57 39.0735L51.2595 37.7865L51.012 36.765L50.697 35.4779L50.454 34.4519L50.1435 33.1695L49.8915 32.1389L49.5225 30.6089L61.0965 32.3009Z"
        fill="white"
      />
      <path
        d="M60.3046 33.6644L59.7691 34.5779L50.1436 33.1694L49.8916 32.1389L60.3046 33.6644Z"
        fill="white"
      />
      <path
        d="M59.1031 35.721L58.5721 36.63L50.6971 35.478L50.4541 34.452L59.1031 35.721Z"
        fill="white"
      />
      <path
        d="M57.9057 37.773L57.3747 38.682L51.2592 37.7865L51.0117 36.765L57.9057 37.773Z"
        fill="white"
      />
      <path
        d="M56.7093 39.825L56.1783 40.734L51.8178 40.0995L51.5703 39.0735L56.7093 39.825Z"
        fill="white"
      />
      <path
        d="M55.5119 41.8815L54.9809 42.7905L52.3754 42.408L52.1279 41.3865L55.5119 41.8815Z"
        fill="white"
      />
      <path
        d="M54.315 43.9334L53.784 44.8425L52.9335 44.721L52.686 43.6949L54.315 43.9334Z"
        fill="white"
      />
      <path
        d="M84.3702 33.579L83.7402 35.0235L83.3172 35.991L82.7862 37.206L82.3677 38.169L81.8367 39.384L81.4137 40.347L80.8872 41.562L80.4642 42.525L79.9332 43.74L79.5102 44.7075L78.9837 45.918L78.5607 46.8855L78.0972 47.9385L77.7012 46.8585L77.3367 45.8685L76.8777 44.631L76.5177 43.641L76.0542 42.399L75.6897 41.409L75.2307 40.167L74.8707 39.177L74.4117 37.9395L74.0472 36.9495L73.5927 35.7075L73.2237 34.7175L72.6792 33.237L84.3702 33.579Z"
        fill="black"
      />
      <path
        d="M83.7401 35.0235L83.3171 35.991L73.5926 35.7075L73.2236 34.7175L83.7401 35.0235Z"
        fill="white"
      />
      <path
        d="M82.7864 37.206L82.3679 38.169L74.4119 37.9395L74.0474 36.9495L82.7864 37.206Z"
        fill="white"
      />
      <path
        d="M81.8366 39.384L81.4136 40.347L75.2306 40.167L74.8706 39.177L81.8366 39.384Z"
        fill="white"
      />
      <path
        d="M80.8874 41.562L80.4644 42.525L76.0544 42.399L75.6899 41.409L80.8874 41.562Z"
        fill="white"
      />
      <path
        d="M79.9331 43.74L79.5101 44.7075L76.8776 44.631L76.5176 43.641L79.9331 43.74Z"
        fill="white"
      />
      <path
        d="M78.9839 45.918L78.5609 46.8855L77.7014 46.8585L77.3369 45.8685L78.9839 45.918Z"
        fill="white"
      />
      <path
        d="M107.708 31.779L107.285 33.2955L107.001 34.317L106.646 35.5905L106.362 36.603L106.007 37.881L105.728 38.8935L105.372 40.167L105.089 41.184L104.733 42.462L104.45 43.4745L104.099 44.7525L103.815 45.765L103.505 46.8765L102.96 45.8595L102.461 44.9325L101.831 43.767L101.336 42.84L100.706 41.6745L100.206 40.7475L99.5806 39.582L99.0811 38.6505L98.4511 37.4895L97.9561 36.558L97.3306 35.3925L96.8266 34.4655L96.0796 33.075L107.708 31.779Z"
        fill={primaryColor}
      />
      <path
        d="M107.285 33.2955L107.001 34.317L97.3307 35.3925L96.8267 34.4655L107.285 33.2955Z"
        fill="white"
      />
      <path
        d="M106.646 35.5905L106.362 36.603L98.4511 37.4895L97.9561 36.558L106.646 35.5905Z"
        fill="white"
      />
      <path
        d="M106.007 37.881L105.728 38.8935L99.5806 39.582L99.0811 38.6505L106.007 37.881Z"
        fill="white"
      />
      <path
        d="M105.372 40.167L105.089 41.184L100.706 41.6745L100.206 40.7475L105.372 40.167Z"
        fill="white"
      />
      <path
        d="M104.733 42.462L104.449 43.4745L101.83 43.767L101.335 42.84L104.733 42.462Z"
        fill="white"
      />
      <path
        d="M104.098 44.7525L103.815 45.765L102.96 45.8595L102.46 44.9325L104.098 44.7525Z"
        fill="white"
      />
      <path
        d="M130.198 26.2395L130.05 27.8055L129.951 28.8585L129.829 30.177L129.73 31.2255L129.609 32.544L129.51 33.5925L129.384 34.911L129.285 35.9595L129.163 37.278L129.064 38.3265L128.943 39.645L128.844 40.6935L128.736 41.841L128.02 40.941L127.363 40.113L126.54 39.078L125.887 38.2545L125.059 37.215L124.402 36.3915L123.583 35.3565L122.926 34.533L122.103 33.498L121.446 32.67L120.627 31.635L119.965 30.8115L118.984 29.5785L130.198 26.2395Z"
        fill={primaryColor}
      />
      <path
        d="M130.05 27.8055L129.951 28.8585L120.627 31.635L119.965 30.8115L130.05 27.8055Z"
        fill="white"
      />
      <path
        d="M129.829 30.177L129.73 31.2255L122.103 33.498L121.446 32.67L129.829 30.177Z"
        fill="white"
      />
      <path
        d="M129.609 32.544L129.51 33.5925L123.583 35.3565L122.926 34.533L129.609 32.544Z"
        fill="white"
      />
      <path
        d="M129.384 34.911L129.285 35.9595L125.059 37.215L124.402 36.3915L129.384 34.911Z"
        fill="white"
      />
      <path
        d="M129.164 37.278L129.065 38.3265L126.54 39.078L125.888 38.2545L129.164 37.278Z"
        fill="white"
      />
      <path
        d="M128.943 39.645L128.844 40.6935L128.02 40.941L127.363 40.113L128.943 39.645Z"
        fill="white"
      />
      <path
        d="M151.11 16.2315L151.272 17.7975L151.384 18.8505L151.524 20.1645L151.632 21.213L151.771 22.527L151.884 23.5755L152.019 24.894L152.131 25.9425L152.271 27.261L152.379 28.305L152.518 29.6235L152.631 30.672L152.752 31.815L151.87 31.0725L151.065 30.393L150.052 29.5425L149.251 28.863L148.234 28.008L147.429 27.3285L146.416 26.4735L145.615 25.794L144.603 24.9435L143.797 24.2595L142.789 23.409L141.979 22.7295L140.773 21.7125L151.11 16.2315Z"
        fill="white"
      />
      <path
        d="M151.272 17.7975L151.384 18.8505L142.789 23.409L141.979 22.7295L151.272 17.7975Z"
        fill="white"
      />
      <path
        d="M151.524 20.1645L151.632 21.213L144.603 24.9435L143.797 24.2595L151.524 20.1645Z"
        fill="white"
      />
      <path
        d="M151.772 22.527L151.884 23.5755L146.417 26.4735L145.616 25.794L151.772 22.527Z"
        fill="white"
      />
      <path
        d="M152.019 24.894L152.132 25.9425L148.235 28.008L147.429 27.3285L152.019 24.894Z"
        fill="white"
      />
      <path
        d="M152.271 27.261L152.379 28.305L150.052 29.5425L149.251 28.863L152.271 27.261Z"
        fill="white"
      />
      <path
        d="M152.518 29.6235L152.631 30.672L151.87 31.0725L151.065 30.393L152.518 29.6235Z"
        fill="white"
      />
      <path
        d="M13.2075 21.051C19.404 23.22 25.722 24.9975 32.094 26.541C38.4615 28.0935 44.8965 29.3895 51.3675 30.402C64.3095 32.436 77.436 33.426 90.5175 32.877C103.59 32.373 116.64 30.2805 129.051 26.1045C141.458 21.9555 153.144 15.5655 163.202 7.12347C158.283 11.466 152.919 15.3225 147.222 18.6075C144.365 20.2365 141.444 21.7575 138.438 23.0985C135.441 24.453 132.386 25.695 129.276 26.7615C126.171 27.846 123.021 28.818 119.826 29.61C116.636 30.4155 113.418 31.1265 110.174 31.68C103.689 32.823 97.128 33.4845 90.5535 33.777C83.979 34.0155 77.391 33.8985 70.83 33.426C64.269 32.9625 57.7305 32.1975 51.255 31.0815C38.313 28.863 25.5015 25.6725 13.2075 21.051Z"
        fill="white"
      />
      <path
        d="M209.515 61.335L198.459 65.151L208.732 76.986L209.515 61.335Z"
        fill={primaryColor}
      />
      <path
        d="M187.25 68.5665L175.878 71.307L184.973 84.069L187.25 68.5665Z"
        fill="black"
      />
      <path
        d="M164.381 73.494L152.775 74.952L160.389 88.6455L164.381 73.494Z"
        fill="white"
      />
      <path
        d="M141.165 75.7214L129.465 75.7709L135.378 90.2834L141.165 75.7214Z"
        fill="white"
      />
      <path
        d="M117.904 74.7314L106.335 72.9764L109.939 88.227L117.904 74.7314Z"
        fill={primaryColor}
      />
      <path
        d="M95.3011 70.209L84.3076 66.213L84.8386 81.8729L95.3011 70.209Z"
        fill={primaryColor}
      />
      <path
        d="M74.0475 61.1234L64.2645 54.7109L61.1865 70.0739L74.0475 61.1234Z"
        fill="black"
      />
      <path
        d="M187.25 68.5665L188.231 69.804L188.888 70.632L189.711 71.667L190.364 72.4905L191.187 73.53L191.844 74.3535L192.663 75.3885L193.32 76.2165L194.144 77.256L194.796 78.0795L195.62 79.119L196.277 79.9425L196.992 80.8425L197.1 79.6995L197.199 78.651L197.325 77.3325L197.419 76.284L197.545 74.9655L197.649 73.9125L197.77 72.5985L197.869 71.55L197.995 70.2315L198.094 69.183L198.216 67.8645L198.319 66.8115L198.468 65.2455L187.25 68.5665Z"
        fill="white"
      />
      <path
        d="M188.23 69.804L188.887 70.632L198.216 67.8645L198.319 66.8115L188.23 69.804Z"
        fill="white"
      />
      <path
        d="M189.711 71.667L190.363 72.4905L197.995 70.2315L198.094 69.183L189.711 71.667Z"
        fill="white"
      />
      <path
        d="M191.187 73.53L191.844 74.3535L197.77 72.5985L197.869 71.55L191.187 73.53Z"
        fill="white"
      />
      <path
        d="M192.663 75.3885L193.32 76.2165L197.546 74.9655L197.649 73.9125L192.663 75.3885Z"
        fill="white"
      />
      <path
        d="M194.144 77.256L194.796 78.0795L197.325 77.3325L197.42 76.284L194.144 77.256Z"
        fill="white"
      />
      <path
        d="M195.62 79.119L196.277 79.9425L197.1 79.6995L197.199 78.651L195.62 79.119Z"
        fill="white"
      />
      <path
        d="M164.385 73.4985L165.231 74.826L165.798 75.717L166.509 76.833L167.076 77.724L167.787 78.84L168.354 79.7265L169.061 80.8425L169.628 81.729L170.339 82.8495L170.906 83.736L171.617 84.852L172.184 85.743L172.805 86.715L173.03 85.5855L173.237 84.5505L173.498 83.2545L173.7 82.2195L173.966 80.919L174.173 79.8885L174.434 78.5925L174.636 77.5575L174.897 76.2615L175.104 75.2265L175.365 73.9305L175.572 72.8955L175.883 71.3475L164.385 73.4985Z"
        fill="white"
      />
      <path
        d="M165.231 74.8259L165.798 75.7169L175.365 73.9304L175.572 72.8954L165.231 74.8259Z"
        fill="white"
      />
      <path
        d="M166.509 76.8329L167.076 77.7239L174.897 76.2614L175.104 75.2264L166.509 76.8329Z"
        fill="white"
      />
      <path
        d="M167.788 78.84L168.355 79.7265L174.434 78.5925L174.637 77.5575L167.788 78.84Z"
        fill="white"
      />
      <path
        d="M169.061 80.8425L169.628 81.729L173.966 80.919L174.173 79.8885L169.061 80.8425Z"
        fill="white"
      />
      <path
        d="M170.338 82.8495L170.905 83.736L173.497 83.2545L173.7 82.2195L170.338 82.8495Z"
        fill="white"
      />
      <path
        d="M171.617 84.852L172.184 85.743L173.03 85.5855L173.237 84.5505L171.617 84.852Z"
        fill="white"
      />
      <path
        d="M141.178 75.69L141.867 77.1075L142.326 78.0615L142.902 79.2495L143.361 80.199L143.937 81.3915L144.4 82.3365L144.976 83.529L145.435 84.474L146.011 85.671L146.47 86.616L147.046 87.8085L147.51 88.758L148.009 89.793L148.365 88.6995L148.693 87.696L149.098 86.436L149.422 85.437L149.832 84.1725L150.16 83.1735L150.57 81.9135L150.889 80.91L151.303 79.6545L151.623 78.651L152.032 77.391L152.361 76.3875L152.847 74.889L141.178 75.69Z"
        fill={primaryColor}
      />
      <path
        d="M141.867 77.1075L142.326 78.0615L152.032 77.391L152.361 76.3875L141.867 77.1075Z"
        fill="white"
      />
      <path
        d="M142.902 79.2495L143.361 80.199L151.303 79.6545L151.623 78.651L142.902 79.2495Z"
        fill="white"
      />
      <path
        d="M143.937 81.3915L144.401 82.3365L150.57 81.9135L150.89 80.91L143.937 81.3915Z"
        fill="white"
      />
      <path
        d="M144.976 83.529L145.435 84.474L149.832 84.1725L150.16 83.1735L144.976 83.529Z"
        fill="white"
      />
      <path
        d="M146.011 85.671L146.47 86.616L149.098 86.436L149.422 85.437L146.011 85.671Z"
        fill="white"
      />
      <path
        d="M147.046 87.8085L147.51 88.758L148.365 88.6995L148.693 87.696L147.046 87.8085Z"
        fill="white"
      />
      <path
        d="M117.788 74.8124L118.274 76.3109L118.598 77.3189L118.998 78.5789L119.322 79.5779L119.727 80.8379L120.051 81.8414L120.452 83.1014L120.776 84.1049L121.181 85.3694L121.505 86.3729L121.905 87.6284L122.229 88.6319L122.585 89.7299L123.089 88.6949L123.552 87.7499L124.133 86.5619L124.592 85.6124L125.177 84.4199L125.636 83.4749L126.216 82.2869L126.68 81.3374L127.26 80.1494L127.719 79.2044L128.3 78.0164L128.768 77.0669L129.456 75.6494L117.788 74.8124Z"
        fill="black"
      />
      <path
        d="M118.273 76.3109L118.597 77.3189L128.299 78.0164L128.767 77.0669L118.273 76.3109Z"
        fill="white"
      />
      <path
        d="M118.998 78.5789L119.322 79.5779L127.26 80.1494L127.719 79.2044L118.998 78.5789Z"
        fill="white"
      />
      <path
        d="M119.727 80.838L120.051 81.8414L126.216 82.2869L126.68 81.3375L119.727 80.838Z"
        fill="white"
      />
      <path
        d="M120.452 83.1014L120.776 84.1049L125.177 84.4199L125.636 83.4749L120.452 83.1014Z"
        fill="white"
      />
      <path
        d="M121.181 85.3694L121.505 86.3729L124.133 86.5619L124.592 85.6124L121.181 85.3694Z"
        fill="white"
      />
      <path
        d="M121.905 87.6284L122.229 88.6319L123.089 88.6949L123.552 87.7499L121.905 87.6284Z"
        fill="white"
      />
      <path
        d="M95.0986 70.1595L95.3101 71.721L95.4496 72.7695L95.6206 74.079L95.7601 75.1275L95.9356 76.437L96.0751 77.481L96.2506 78.7905L96.3901 79.839L96.5656 81.153L96.7051 82.197L96.8806 83.5065L97.0201 84.5505L97.1731 85.6935L97.8526 84.7665L98.4736 83.916L99.2566 82.8495L99.8776 81.999L100.665 80.928L101.286 80.0775L102.069 79.011L102.69 78.1605L103.473 77.094L104.094 76.2435L104.877 75.177L105.503 74.3265L106.434 73.053L95.0986 70.1595Z"
        fill="white"
      />
      <path
        d="M95.3101 71.7209L95.4496 72.7695L104.877 75.177L105.503 74.3265L95.3101 71.7209Z"
        fill="white"
      />
      <path
        d="M95.6206 74.079L95.7601 75.1275L103.473 77.094L104.094 76.2435L95.6206 74.079Z"
        fill="white"
      />
      <path
        d="M95.9355 76.437L96.075 77.481L102.069 79.011L102.69 78.1605L95.9355 76.437Z"
        fill="white"
      />
      <path
        d="M96.2505 78.7905L96.39 79.839L100.665 80.928L101.286 80.0775L96.2505 78.7905Z"
        fill="white"
      />
      <path
        d="M96.5659 81.153L96.7054 82.197L99.2569 82.8495L99.8779 81.999L96.5659 81.153Z"
        fill="white"
      />
      <path
        d="M96.8809 83.5065L97.0204 84.5505L97.8529 84.7665L98.4739 83.916L96.8809 83.5065Z"
        fill="white"
      />
      <path
        d="M74.025 61.0964L73.9215 62.6669L73.8495 63.7244L73.764 65.0429L73.6965 66.0959L73.611 67.4144L73.539 68.4674L73.4535 69.7859L73.386 70.8389L73.296 72.1619L73.2285 73.2104L73.1385 74.5334L73.071 75.5819L72.999 76.7339L73.8495 75.9554L74.628 75.2444L75.6045 74.3534L76.3785 73.6424L77.3595 72.7469L78.138 72.0359L79.1145 71.1449L79.8885 70.4339L80.8695 69.5429L81.6435 68.8319L82.62 67.9409L83.403 67.2254L84.564 66.1634L74.025 61.0964Z"
        fill="white"
      />
      <path
        d="M73.9216 62.6669L73.8496 63.7244L82.6201 67.9409L83.4031 67.2254L73.9216 62.6669Z"
        fill="white"
      />
      <path
        d="M73.7643 65.0429L73.6968 66.0959L80.8698 69.5429L81.6438 68.8319L73.7643 65.0429Z"
        fill="white"
      />
      <path
        d="M73.6111 67.4144L73.5391 68.4674L79.1146 71.1449L79.8886 70.4339L73.6111 67.4144Z"
        fill="white"
      />
      <path
        d="M73.4537 69.7859L73.3862 70.8389L77.3597 72.7469L78.1382 72.0359L73.4537 69.7859Z"
        fill="white"
      />
      <path
        d="M73.296 72.1619L73.2285 73.2104L75.6045 74.3534L76.3785 73.6424L73.296 72.1619Z"
        fill="white"
      />
      <path
        d="M73.1383 74.5334L73.0708 75.582L73.8493 75.9555L74.6278 75.2445L73.1383 74.5334Z"
        fill="white"
      />
      <path
        d="M211.793 60.3675C199.693 65.4705 187.016 69.1605 174.164 71.892C167.734 73.26 161.231 74.2815 154.697 75.006C148.163 75.735 141.584 76.113 135.005 76.1355C128.426 76.104 121.843 75.699 115.318 74.8125C112.055 74.385 108.811 73.8 105.593 73.125C102.371 72.459 99.1854 71.613 96.0354 70.65C92.8809 69.705 89.7849 68.5845 86.7339 67.3515C83.6784 66.132 80.6994 64.728 77.7789 63.2115C71.9559 60.156 66.4434 56.5155 61.3584 52.3665C71.7444 60.408 83.6739 66.33 96.2334 69.9885C108.797 73.674 121.924 75.249 135.005 75.24C148.1 75.276 161.177 73.7685 174.029 71.2215C180.46 69.9525 186.836 68.409 193.136 66.6045C199.441 64.809 205.687 62.7795 211.793 60.3675Z"
        fill="white"
      />
      <path
        d="M83.2768 31.9095C83.3578 32.5305 82.9213 33.1019 82.3003 33.1829C81.6793 33.2639 81.1078 32.8274 81.0268 32.2065C80.9458 31.5855 81.3823 31.014 82.0033 30.933C82.6243 30.852 83.1958 31.2885 83.2768 31.9095Z"
        fill="white"
      />
      <path
        d="M98.5273 80.568C98.6083 81.189 98.1718 81.7605 97.5508 81.8415C96.9298 81.9225 96.3583 81.486 96.2773 80.865C96.1963 80.244 96.6328 79.6725 97.2538 79.5915C97.8748 79.515 98.4463 79.9515 98.5273 80.568Z"
        fill="white"
      />
      <path
        d="M84.0419 71.8559C84.1229 72.4769 83.6864 73.0484 83.0654 73.1294C82.4444 73.2104 81.8729 72.7739 81.7919 72.1529C81.7109 71.5319 82.1474 70.9604 82.7684 70.8794C83.3894 70.7984 83.9564 71.2349 84.0419 71.8559Z"
        fill="white"
      />
      <path
        d="M51.3222 47.961C51.3627 48.2715 51.1467 48.555 50.8362 48.5955C50.5257 48.636 50.2422 48.42 50.2017 48.1095C50.1612 47.799 50.3772 47.5155 50.6877 47.475C50.9937 47.4345 51.2772 47.6505 51.3222 47.961Z"
        fill="white"
      />
      <path
        d="M163.337 71.4735C163.377 71.784 163.161 72.0675 162.851 72.108C162.54 72.1485 162.257 71.9325 162.216 71.622C162.176 71.3115 162.392 71.028 162.702 70.9875C163.008 70.9425 163.296 71.163 163.337 71.4735Z"
        fill="white"
      />
      <path
        d="M84.9061 82.3364C84.9466 82.6469 84.7306 82.9304 84.4201 82.9709C84.1096 83.0114 83.8261 82.7954 83.7856 82.4849C83.7451 82.1744 83.9611 81.8909 84.2716 81.8504C84.5776 81.8054 84.8611 82.0259 84.9061 82.3364Z"
        fill="white"
      />
      <path
        d="M189.252 45.2879C189.292 45.5984 189.076 45.8819 188.766 45.9224C188.455 45.9629 188.172 45.7469 188.131 45.4364C188.091 45.1259 188.307 44.8424 188.617 44.8019C188.928 44.7614 189.211 44.9774 189.252 45.2879Z"
        fill="white"
      />
      <path
        d="M129.344 99.153C129.384 99.4635 129.168 99.7469 128.858 99.7874C128.547 99.8279 128.264 99.612 128.223 99.3015C128.183 98.991 128.399 98.7075 128.709 98.667C129.02 98.622 129.303 98.8425 129.344 99.153Z"
        fill="white"
      />
      <path
        d="M188.118 70.29C188.159 70.6005 187.943 70.884 187.632 70.9245C187.322 70.965 187.038 70.749 186.998 70.4385C186.957 70.128 187.173 69.8445 187.484 69.804C187.794 69.7635 188.078 69.9795 188.118 70.29Z"
        fill="white"
      />
      <path
        d="M154.431 40.8915C154.472 41.202 154.256 41.4855 153.945 41.526C153.635 41.5665 153.351 41.3505 153.311 41.04C153.27 40.7295 153.486 40.446 153.797 40.4055C154.107 40.365 154.391 40.581 154.431 40.8915Z"
        fill="white"
      />
      <path
        d="M34.6005 88.1279C34.641 88.4384 34.425 88.7219 34.1145 88.7624C33.804 88.8029 33.5205 88.5869 33.48 88.2764C33.4395 87.9659 33.6555 87.6824 33.966 87.6419C34.2765 87.5969 34.56 87.8174 34.6005 88.1279Z"
        fill="white"
      />
      <path
        d="M118.066 38.5695C118.107 38.88 117.891 39.1635 117.58 39.204C117.27 39.2445 116.986 39.0285 116.946 38.718C116.905 38.4075 117.121 38.124 117.432 38.0835C117.738 38.043 118.026 38.259 118.066 38.5695Z"
        fill="white"
      />
      <path
        d="M56.2499 93.9465C56.2904 94.257 56.0744 94.5405 55.7639 94.581C55.4534 94.6215 55.1699 94.4055 55.1294 94.095C55.0889 93.7845 55.3049 93.501 55.6154 93.4605C55.9259 93.4155 56.2094 93.636 56.2499 93.9465Z"
        fill="white"
      />
      <path
        d="M65.3041 77.5575C65.3851 78.1785 64.9486 78.7499 64.3276 78.8309C63.7066 78.9119 63.1351 78.4755 63.0541 77.8545C62.9731 77.2335 63.4096 76.662 64.0306 76.581C64.6516 76.5 65.2231 76.9365 65.3041 77.5575Z"
        fill="white"
      />
      <path
        d="M110.799 59.8095C110.88 60.4305 110.443 61.002 109.822 61.083C109.201 61.164 108.63 60.7275 108.549 60.1065C108.468 59.4855 108.904 58.914 109.525 58.833C110.146 58.752 110.718 59.1885 110.799 59.8095Z"
        fill="white"
      />
      <path
        d="M156.127 55.5929C156.208 56.2139 155.772 56.7854 155.151 56.8664C154.53 56.9474 153.958 56.5109 153.877 55.8899C153.796 55.2689 154.233 54.6974 154.854 54.6164C155.475 54.5354 156.046 54.9719 156.127 55.5929Z"
        fill="white"
      />
      <path
        d="M127.287 53.3339L125.703 52.7399C125.703 52.7399 126.198 53.8694 125.091 55.2284C123.984 56.5919 122.382 56.1824 121.882 57.8249L123.574 58.5809C123.574 58.5809 123.88 57.0869 125.208 56.4434C126.207 55.9529 127.296 55.2914 127.287 53.3339Z"
        fill="white"
      />
      <path
        d="M91.3005 86.4404L89.7165 85.8464C89.7165 85.8464 90.2115 86.9759 89.1045 88.3349C87.9975 89.6984 86.3955 89.2889 85.896 90.9314L87.588 91.6874C87.588 91.6874 87.894 90.1934 89.2215 89.5499C90.225 89.0594 91.314 88.4024 91.3005 86.4404Z"
        fill="white"
      />
      <path
        d="M128.677 87.1065L127.093 86.5125C127.093 86.5125 127.588 87.6419 126.481 89.0009C125.374 90.3644 123.772 89.9549 123.273 91.5974L124.965 92.3534C124.965 92.3534 125.271 90.8594 126.598 90.2159C127.602 89.7254 128.691 89.064 128.677 87.1065Z"
        fill="white"
      />
      <path
        d="M163.17 85.8779L161.586 85.2839C161.586 85.2839 162.081 86.4134 160.974 87.7724C159.867 89.1359 158.265 88.7264 157.766 90.3689L159.458 91.1249C159.458 91.1249 159.764 89.6309 161.091 88.9874C162.095 88.4924 163.184 87.8354 163.17 85.8779Z"
        fill="white"
      />
      <path
        d="M72.2339 62.6624L72.4634 60.9839C72.4634 60.9839 71.4734 61.7129 69.8984 60.9344C68.3234 60.1559 68.3684 58.5044 66.6584 58.3829L66.2939 60.1964C66.2939 60.1964 67.8194 60.1649 68.7419 61.3169C69.4439 62.1944 70.3259 63.1079 72.2339 62.6624Z"
        fill="white"
      />
      <path
        d="M142.42 59.67L142.65 57.9914C142.65 57.9914 141.66 58.7204 140.085 57.9419C138.51 57.1634 138.555 55.5119 136.845 55.3904L136.48 57.2039C136.48 57.2039 138.006 57.1724 138.928 58.3245C139.63 59.202 140.512 60.1155 142.42 59.67Z"
        fill="white"
      />
      <path
        d="M70.8838 101.308L71.1133 99.6299C71.1133 99.6299 70.1233 100.359 68.5483 99.5804C66.9733 98.8019 67.0183 97.1504 65.3083 97.0289L64.9438 98.8424C64.9438 98.8424 66.4693 98.8109 67.3918 99.9629C68.0893 100.836 68.9758 101.749 70.8838 101.308Z"
        fill="white"
      />
      <path
        d="M174.767 54.261L174.996 52.5824C174.996 52.5824 174.006 53.3114 172.431 52.5329C170.856 51.7544 170.901 50.1029 169.191 49.9814L168.827 51.7949C168.827 51.7949 170.352 51.7634 171.275 52.9154C171.972 53.7884 172.859 54.702 174.767 54.261Z"
        fill="white"
      />
      <path
        d="M157.153 103.788L157.473 105.448C157.473 105.448 158.175 104.436 159.916 104.67C161.658 104.904 162.144 106.479 163.804 106.047L163.566 104.211C163.566 104.211 162.13 104.728 160.888 103.936C159.948 103.338 158.818 102.753 157.153 103.788Z"
        fill="white"
      />
      <path
        d="M81.585 98.5995L84.2895 97.8345C84.2895 97.8345 85.5765 101.209 82.899 102.163C82.899 102.163 83.808 100.363 81.585 98.5995Z"
        fill="white"
      />
      <path
        d="M82.0261 105.727L79.7041 104.215C79.7041 104.215 80.0461 102.01 82.8946 102.159C82.8991 102.163 80.7346 103.743 82.0261 105.727Z"
        fill="white"
      />
      <path
        d="M47.3175 102.748L45.5355 101.781C45.5355 101.781 44.0911 103.959 45.828 105.057C45.8235 105.057 45.468 103.644 47.3175 102.748Z"
        fill="white"
      />
      <path
        d="M45.8731 107.707L47.7496 107.01C47.7496 107.01 47.8576 105.403 45.8281 105.057C45.8236 105.057 47.1016 106.515 45.8731 107.707Z"
        fill="white"
      />
      <path
        d="M139.568 95.1704L137.786 94.2029C137.786 94.2029 136.341 96.3809 138.078 97.4789C138.078 97.4789 137.718 96.0659 139.568 95.1704Z"
        fill="white"
      />
      <path
        d="M138.123 100.129L140 99.4319C140 99.4319 140.108 97.8254 138.078 97.4789C138.078 97.4789 139.352 98.9369 138.123 100.129Z"
        fill="white"
      />
      <path
        d="M146.794 107.221C146.713 106.6 147.15 106.029 147.771 105.948C148.392 105.867 148.963 106.303 149.044 106.924C149.125 107.545 148.689 108.117 148.068 108.198C147.447 108.279 146.875 107.842 146.794 107.221Z"
        fill="white"
      />
      <path
        d="M189.266 94.7339C189.185 94.1129 189.621 93.5414 190.242 93.4604C190.863 93.3794 191.435 93.8159 191.516 94.4369C191.597 95.0579 191.16 95.6294 190.539 95.7104C189.918 95.7914 189.351 95.3549 189.266 94.7339Z"
        fill="white"
      />
      <path
        d="M126.526 67.9185C126.445 67.2975 126.882 66.726 127.503 66.645C128.124 66.564 128.695 67.0005 128.776 67.6215C128.857 68.2425 128.421 68.814 127.8 68.895C127.179 68.976 126.607 68.5395 126.526 67.9185Z"
        fill="white"
      />
      <path
        d="M176.18 76.4414L175.95 78.1199C175.95 78.1199 176.94 77.3909 178.515 78.1694C180.09 78.9479 180.045 80.5994 181.755 80.7209L182.12 78.9074C182.12 78.9074 180.594 78.9389 179.672 77.7869C178.97 76.9139 178.088 75.9959 176.18 76.4414Z"
        fill="white"
      />
      <path
        d="M137.52 75.924L134.816 76.689C134.816 76.689 133.529 73.314 136.206 72.36C136.206 72.36 135.297 74.16 137.52 75.924Z"
        fill="white"
      />
      <path
        d="M137.075 68.796L139.397 70.308C139.397 70.308 139.055 72.5129 136.206 72.3644C136.206 72.3599 138.371 70.7805 137.075 68.796Z"
        fill="white"
      />
      <path
        d="M47.8667 82.935L45.1622 83.7C45.1622 83.7 43.8752 80.325 46.5527 79.371C46.5527 79.371 45.6437 81.171 47.8667 82.935Z"
        fill="white"
      />
      <path
        d="M47.4212 75.8069L49.7432 77.3189C49.7432 77.3189 49.4012 79.5239 46.5527 79.3754C46.5527 79.3709 48.7172 77.7914 47.4212 75.8069Z"
        fill="white"
      />
      <path
        d="M178.938 109.701L180.72 110.668C180.72 110.668 182.164 108.49 180.427 107.392C180.427 107.397 180.783 108.81 178.938 109.701Z"
        fill="white"
      />
      <path
        d="M180.378 104.746L178.501 105.444C178.501 105.444 178.393 107.05 180.423 107.397C180.427 107.397 179.154 105.939 180.378 104.746Z"
        fill="white"
      />
      <path
        d="M164.588 38.511L166.37 39.4785C166.37 39.4785 167.814 37.3005 166.077 36.2025C166.077 36.207 166.433 37.62 164.588 38.511Z"
        fill="white"
      />
      <path
        d="M166.028 33.5519L164.151 34.2494C164.151 34.2494 164.043 35.8559 166.073 36.2024C166.077 36.2069 164.804 34.7489 166.028 33.5519Z"
        fill="white"
      />
      <path
        d="M94.5537 97.4744L94.8507 99.4814C94.8507 99.4814 97.4562 99.3284 97.2942 97.2809C97.2897 97.2854 96.3762 98.4194 94.5537 97.4744Z"
        fill="white"
      />
      <path
        d="M99.3821 95.652L97.6991 94.572C97.6991 94.572 96.3491 95.4495 97.2896 97.2809C97.2896 97.2854 97.6901 95.391 99.3821 95.652Z"
        fill="white"
      />
      <path
        d="M112.5 209.511C155.277 209.511 189.954 204.829 189.954 199.053C189.954 193.277 155.277 188.595 112.5 188.595C69.7232 188.595 35.0459 193.277 35.0459 199.053C35.0459 204.829 69.7232 209.511 112.5 209.511Z"
        fill="white"
      />
      <path
        d="M15.5566 173.326L39.7891 173.218L64.0261 173.178L112.5 173.102L160.974 173.178L185.211 173.218L209.444 173.326L185.211 173.439L160.974 173.475L112.5 173.551L64.0261 173.475L39.7891 173.439L15.5566 173.326Z"
        fill="black"
      />
      <path
        d="M38.5424 139.815C38.5424 139.815 29.4119 137.745 24.4079 133.132C19.4039 128.52 16.6094 120.258 16.6094 120.258C16.6094 120.258 21.9824 121.243 26.8514 122.949C27.6659 123.822 29.2229 125.626 29.9474 127.327C29.9474 127.327 30.1004 125.527 29.9699 124.195C31.2704 124.794 32.4044 125.46 33.2234 126.171C37.3724 129.807 38.5424 139.815 38.5424 139.815Z"
        fill="#FFC727"
      />
      <path
        d="M22.3109 124.276C21.0644 123.417 19.7999 122.584 18.5579 121.716C18.4814 121.662 18.5534 121.545 18.6344 121.594C20.9879 122.998 23.3054 124.501 25.5509 126.076C26.3339 126.625 27.1034 127.197 27.8594 127.777C27.8054 127.687 27.7559 127.597 27.7019 127.507C27.4274 127.048 27.1394 126.598 26.8514 126.148C26.2709 125.244 25.6364 124.357 24.9119 123.561C24.8849 123.529 24.9299 123.489 24.9569 123.516C25.6679 124.335 26.3789 125.149 27.0269 126.018C27.3374 126.432 27.6209 126.859 27.8954 127.296C28.0394 127.521 28.1744 127.75 28.3049 127.984C28.3499 128.061 28.3949 128.142 28.4399 128.218C29.6189 129.145 30.7709 130.113 31.8689 131.134C32.5439 131.764 33.2009 132.421 33.8309 133.092C33.4799 131.985 33.1694 130.869 32.7599 129.78C32.7464 129.744 32.8049 129.726 32.8184 129.766C33.2144 130.909 33.6509 132.052 33.9569 133.227C34.6589 133.983 35.3249 134.766 35.9549 135.58C35.9459 135.531 35.9324 135.481 35.9234 135.432C35.8199 135 35.7119 134.572 35.5949 134.145C35.3744 133.317 35.1314 132.498 34.8524 131.688C34.2809 130.027 33.5384 128.403 32.3999 127.053C32.3729 127.021 32.4179 126.981 32.4449 127.008C34.2269 129.118 35.2754 131.652 35.9414 134.311C36.0404 134.698 36.1304 135.09 36.2204 135.481C36.2654 135.688 36.3239 135.9 36.3554 136.111C36.6299 136.485 36.9044 136.863 37.1609 137.245C38.7449 139.603 39.9824 142.182 41.0264 144.823C42.2009 147.798 43.1144 150.867 43.9514 153.945C43.9694 154.003 43.8794 154.026 43.8569 153.967C42.0704 148.626 40.2479 143.203 37.1924 138.429C36.5489 137.421 35.8469 136.449 35.1089 135.513C33.6059 135.427 32.0894 135.103 30.6674 134.626C29.0924 134.1 27.6119 133.375 26.2169 132.475C25.4114 131.958 24.6824 131.35 23.9354 130.752C23.8994 130.725 23.9399 130.675 23.9759 130.702C25.2089 131.746 26.6939 132.565 28.1609 133.236C29.6324 133.911 31.1849 134.437 32.7689 134.779C33.4439 134.928 34.1279 135.036 34.8119 135.126C33.9659 134.086 33.0659 133.092 32.1209 132.142C31.8149 131.836 31.4954 131.539 31.1759 131.242C30.1274 130.477 28.9664 129.87 27.8009 129.307C26.3069 128.583 24.8309 127.818 23.3504 127.066C22.5134 126.643 21.6854 126.207 20.8439 125.797C20.8079 125.779 20.8394 125.725 20.8754 125.743C22.3739 126.468 23.8994 127.147 25.4159 127.84C26.8424 128.493 28.2824 129.15 29.6504 129.919C29.7089 129.951 29.7629 129.987 29.8214 130.023C28.5839 128.947 27.3059 127.921 25.9964 126.931C24.7859 126.036 23.5574 125.14 22.3109 124.276Z"
        fill="black"
      />
      <path
        d="M22.8283 128.983C23.5708 129.307 24.3268 129.595 25.0603 129.942C25.8163 130.297 26.5318 130.707 27.2518 131.134C27.2833 131.152 27.2563 131.197 27.2203 131.184C26.4913 130.837 25.7533 130.509 25.0333 130.149C24.2953 129.775 23.5663 129.379 22.8058 129.046C22.7743 129.028 22.7923 128.97 22.8283 128.983Z"
        fill="black"
      />
      <path
        d="M68.2062 93.798C68.2062 93.798 65.6412 96.732 65.4792 101.38C65.4477 102.199 65.5782 103.342 65.6727 104.683C62.2662 106.501 59.7147 109.777 59.7147 109.777C61.6497 108.616 64.3047 108.148 65.7357 108.337C65.6862 109.219 65.5827 110.137 65.3892 111.064C64.7547 111.028 63.5352 111.114 61.5147 111.829C61.5147 111.829 63.4947 111.78 65.0067 112.522C63.3777 117.702 58.5402 123.021 45.1797 125.28C45.1797 125.28 42.6012 116.208 47.5467 106.479C51.5472 98.6085 68.2062 93.798 68.2062 93.798Z"
        fill="#FFC727"
      />
      <path
        d="M40.5539 147.438C40.7879 145.224 41.0759 143.019 41.4179 140.823C42.1019 136.426 42.9884 132.052 44.1134 127.746C44.6444 125.716 45.2789 123.727 46.0439 121.788C45.9944 121.437 46.0034 121.072 45.9944 120.717C45.9854 120.289 45.9809 119.862 45.9899 119.434C45.9989 118.579 46.0394 117.724 46.1114 116.869C46.2554 115.186 46.5119 113.499 46.9304 111.861C47.1734 110.911 47.4569 109.971 47.7359 109.03C47.7494 108.99 47.8079 109.008 47.7944 109.048C47.3219 110.677 47.0519 112.374 46.8089 114.048C46.5704 115.708 46.4219 117.387 46.3589 119.061C46.3409 119.52 46.3319 119.979 46.3319 120.438C46.3319 120.631 46.3409 120.829 46.3454 121.027C47.0024 119.439 47.7449 117.882 48.5954 116.37C49.9409 113.976 51.4889 111.703 53.1674 109.53C53.1539 109.282 53.2259 109.021 53.2754 108.783C53.3384 108.486 53.4014 108.184 53.4689 107.887C53.6039 107.275 53.7569 106.668 53.9234 106.065C54.2564 104.854 54.6929 103.684 55.0709 102.487C55.0844 102.451 55.1429 102.465 55.1294 102.505C54.7784 103.689 54.5444 104.913 54.2699 106.119C54.1349 106.713 54.0044 107.311 53.8739 107.905C53.8064 108.202 53.7434 108.504 53.6849 108.801C53.6804 108.823 53.6759 108.846 53.6714 108.868C54.2114 108.189 54.7604 107.514 55.3274 106.852C57.8789 103.86 60.6779 101.101 63.4904 98.361C63.8369 98.0235 64.1924 97.695 64.5434 97.362C64.5704 97.335 64.6154 97.38 64.5884 97.407C61.8974 100.215 59.2469 103.054 56.7404 106.024C56.1464 106.731 55.5569 107.446 54.9809 108.171C55.2824 107.964 55.5929 107.766 55.8944 107.568C56.6729 107.059 57.4604 106.564 58.2704 106.11C59.0804 105.655 59.8994 105.21 60.7319 104.8C61.5869 104.377 62.5049 104.031 63.3329 103.549C63.3689 103.527 63.4004 103.59 63.3644 103.603C62.5139 103.954 61.7174 104.485 60.9254 104.953C60.1109 105.435 59.3009 105.921 58.4999 106.429C57.7169 106.929 56.9249 107.419 56.1464 107.923C55.4984 108.346 54.8549 108.805 54.1844 109.197C52.6454 111.195 51.1964 113.26 49.9049 115.425C49.0904 116.788 48.3569 118.188 47.6909 119.619C47.8529 119.551 48.0104 119.479 48.1679 119.412C48.5774 119.232 48.9824 119.052 49.3919 118.867C50.1794 118.516 50.9669 118.179 51.7544 117.837C53.2529 117.184 54.7739 116.586 56.2454 115.87C57.0689 115.47 57.8789 115.047 58.6439 114.538C58.6754 114.516 58.7069 114.57 58.6754 114.592C55.9349 116.482 52.8659 117.81 49.8329 119.151L48.5189 119.731C48.1589 119.889 47.7944 120.069 47.4254 120.208C46.5299 122.211 45.7739 124.276 45.1664 126.4C43.9514 130.644 43.0244 134.977 42.2594 139.324C41.4944 143.689 40.9769 148.081 40.5764 152.491C40.5269 153.04 40.4774 153.594 40.4144 154.143C40.3874 154.363 40.0634 154.363 40.0679 154.134C40.0904 151.911 40.3199 149.665 40.5539 147.438Z"
        fill="black"
      />
      <path
        d="M48.6857 110.542C48.9287 109.183 49.2932 107.856 49.6577 106.528C49.6667 106.488 49.7252 106.506 49.7162 106.546C49.3787 107.851 49.1357 109.183 48.8927 110.506C48.6407 111.856 48.4202 113.211 48.2312 114.574C48.2267 114.597 48.1907 114.597 48.1952 114.574C48.2807 113.22 48.4427 111.879 48.6857 110.542Z"
        fill="black"
      />
      <path
        d="M54.4411 114.228C55.3456 113.589 56.3626 113.103 57.3481 112.594C57.8341 112.342 58.3291 112.104 58.8196 111.865C59.3281 111.618 59.8546 111.415 60.3586 111.159C60.3946 111.141 60.4261 111.195 60.3901 111.213C59.8996 111.456 59.4361 111.753 58.9591 112.018C58.4641 112.288 57.9736 112.563 57.4741 112.828C56.4976 113.355 55.5346 113.935 54.5131 114.358C54.4231 114.394 54.3646 114.282 54.4411 114.228Z"
        fill="black"
      />
      <path
        opacity="0.1"
        d="M38.3803 123.998C38.3803 123.998 29.9293 121.982 26.0503 116.312C22.3468 110.898 21.1498 101.673 21.0508 100.859C21.2038 101.601 22.9453 109.67 28.7008 113.423C33.1018 116.303 37.3588 118.67 38.3803 123.998Z"
        fill="black"
      />
      <path
        d="M30.5817 109.399C32.0667 110.83 33.1827 112.513 33.6957 114.529C33.7002 114.547 33.6732 114.556 33.6687 114.538C33.0342 112.662 31.9857 110.813 30.5367 109.445C30.5097 109.418 30.5502 109.372 30.5817 109.399Z"
        fill="black"
      />
      <path
        d="M38.3805 123.997C38.3805 123.997 29.9295 121.981 26.0505 116.311C22.347 110.898 21.15 101.673 21.051 100.858C21.042 100.822 21.042 100.8 21.042 100.8C21.042 100.8 25.092 106.56 29.3535 108.031C33.615 109.503 39.6 114.583 38.3805 123.997Z"
        fill="#FFC727"
      />
      <path
        d="M22.5405 103.981C23.3235 105.52 24.147 107.041 25.1505 108.45C26.1315 109.818 27.3105 110.983 28.6245 112.027C29.772 112.941 30.987 113.764 32.148 114.66C32.139 114.646 32.13 114.633 32.121 114.619C31.905 114.295 31.671 113.98 31.428 113.674C30.942 113.058 30.4155 112.473 29.8845 111.897C28.836 110.758 27.7605 109.642 26.82 108.405C26.298 107.721 25.839 106.996 25.4655 106.222C25.4475 106.186 25.506 106.168 25.524 106.204C26.892 109.062 29.6325 110.889 31.5855 113.301C31.8645 113.643 32.1255 113.998 32.3685 114.367C32.5395 114.628 32.7465 114.921 32.8545 115.227C33.9165 116.1 34.8975 117.045 35.739 118.138C35.667 117.585 35.5455 117.031 35.4015 116.496C35.19 115.74 34.9155 115.029 34.506 114.358C34.4835 114.322 34.5375 114.291 34.56 114.322C34.956 114.988 35.316 115.708 35.5455 116.446C35.73 117.049 35.82 117.652 35.8515 118.269L35.856 118.273C36.279 118.84 36.6525 119.434 36.999 120.046C36.963 119.866 36.9315 119.686 36.8955 119.506C36.729 118.665 36.5445 117.823 36.324 116.995C35.8785 115.312 35.2845 113.679 34.29 112.234C34.2675 112.203 34.317 112.167 34.3395 112.198C35.316 113.625 36.0585 115.213 36.5895 116.856C36.8595 117.684 37.0755 118.53 37.2645 119.38C37.359 119.794 37.44 120.213 37.521 120.631C37.5615 120.847 37.611 121.068 37.6425 121.293C38.5065 123.12 39.114 125.077 39.591 127.021C40.4505 130.522 40.9905 134.122 41.391 137.704C41.814 141.462 42.0345 145.264 41.9715 149.049C41.9625 149.526 41.9355 149.998 41.9085 150.471C41.8995 150.592 41.7195 150.61 41.715 150.48C41.634 148.603 41.5845 146.727 41.472 144.855C41.3595 142.978 41.1975 141.111 40.995 139.243C40.599 135.58 40.032 131.917 39.2355 128.317C38.5515 125.23 37.6605 122.121 35.973 119.412C35.127 118.057 34.1145 116.856 32.9265 115.785C31.743 114.723 30.447 113.791 29.196 112.806C27.954 111.825 26.757 110.758 25.776 109.516C24.714 108.175 23.877 106.668 23.0895 105.156C22.8915 104.773 22.6845 104.391 22.4865 104.013C22.4685 103.981 22.5225 103.945 22.5405 103.981Z"
        fill="black"
      />
      <path
        d="M23.9986 105.219C24.5386 106.362 25.1911 107.451 25.8796 108.509C25.8976 108.536 25.8571 108.558 25.8391 108.536C25.1011 107.496 24.4891 106.385 23.9356 105.237C23.9221 105.206 23.9806 105.183 23.9986 105.219Z"
        fill="black"
      />
      <path
        d="M69.3852 120.262C69.3852 120.262 69.5202 132.268 62.3382 135.738C55.1607 139.207 51.3087 136.318 46.4307 137.479C46.4307 137.479 46.4352 137.479 46.4397 137.475C46.6287 137.187 50.1117 132.183 55.6467 130.806C61.3437 129.379 67.6572 125.266 69.3852 120.262Z"
        fill="#FFC727"
      />
      <path
        opacity="0.1"
        d="M69.3852 120.262C69.3852 120.262 69.5202 132.268 62.3382 135.738C55.1607 139.207 51.3087 136.318 46.4307 137.479C46.4307 137.479 46.4352 137.479 46.4397 137.475C46.6422 137.376 50.2062 135.594 54.6027 135.067C59.1297 134.518 67.7787 131.566 69.3852 120.262Z"
        fill="white"
      />
      <path
        d="M45.9582 137.691C46.8132 136.921 47.7717 136.255 48.8157 135.756C48.9687 135.684 49.1262 135.621 49.2837 135.558C49.3602 135.463 49.4412 135.369 49.5267 135.283C49.7427 135.058 49.9677 134.842 50.2017 134.64C50.6517 134.253 51.1332 133.897 51.6462 133.596C52.8342 132.898 54.1392 132.408 55.3542 131.76C55.3902 131.742 55.4217 131.796 55.3857 131.814C54.7827 132.124 54.2022 132.471 53.6172 132.813C53.0502 133.146 52.4652 133.461 51.9117 133.821C51.4167 134.14 50.9352 134.496 50.4897 134.887C50.3637 135 50.2422 135.117 50.1207 135.238C50.9127 134.968 51.7272 134.761 52.5462 134.595C53.8602 134.329 55.1877 134.14 56.5017 133.861C57.1452 133.722 57.7842 133.551 58.4052 133.348C58.9992 132.867 59.5977 132.39 60.1602 131.872C60.8397 131.242 61.4652 130.563 62.0142 129.816C62.0367 129.784 62.0907 129.816 62.0682 129.847C61.1817 130.99 60.2322 132.142 59.1252 133.096C59.4357 132.979 59.7417 132.853 60.0432 132.714C62.4822 131.607 64.6512 129.847 66.1632 127.624C66.1857 127.593 66.2397 127.624 66.2172 127.656C64.9032 129.559 63.2337 131.188 61.2672 132.408C60.2817 133.02 59.2422 133.519 58.1397 133.888C56.8752 134.311 55.5612 134.563 54.2517 134.806C52.9692 135.045 51.6822 135.292 50.4447 135.711C49.3017 136.098 48.2217 136.665 47.2542 137.389C45.4047 138.775 43.9782 140.665 42.9522 142.722C41.5932 145.449 40.9452 148.495 40.5852 151.501C40.5717 151.632 40.3692 151.632 40.3782 151.497C40.7202 146.448 42.0702 141.196 45.9582 137.691Z"
        fill="black"
      />
      <path
        d="M54.2921 133.776C54.6521 133.204 55.1876 132.772 55.7681 132.439C56.4476 132.048 57.0551 131.625 57.5231 130.986C57.5456 130.954 57.5996 130.986 57.5771 131.017C57.1451 131.575 56.6231 132.03 56.0291 132.408C55.4036 132.799 54.7691 133.186 54.3416 133.803C54.3146 133.83 54.2741 133.803 54.2921 133.776Z"
        fill="black"
      />
      <path
        d="M50.4811 146.551L50.1571 153.153L49.1537 173.326H34.0922L33.0931 153.153L32.7646 146.551H50.4811Z"
        fill={primaryColor}
      />
      <path
        d="M50.4811 146.551L50.1571 153.153H33.0931L32.7646 146.551H50.4811Z"
        fill="black"
      />
      <path
        d="M51.534 143.797H31.707V150.097H51.534V143.797Z"
        fill={primaryColor}
      />
      <path
        d="M42.6508 76.428L96.7364 67.2345L89.0369 49.2255L34.4023 60.876L42.6508 76.428Z"
        fill="#FFC727"
      />
      <path
        opacity="0.2"
        d="M42.6508 76.428L96.7364 67.2345L89.0369 49.2255L34.4023 60.876L42.6508 76.428Z"
        fill="white"
      />
      <path
        d="M155.772 34.56L150.601 16.875L89.0366 49.2255L96.7361 67.2345L155.772 34.56Z"
        fill="#FFC727"
      />
      <path
        opacity="0.1"
        d="M155.772 34.56L150.601 16.875L89.0366 49.2255L96.7361 67.2345L155.772 34.56Z"
        fill="white"
      />
      <path
        d="M60.5655 73.3815L76.6215 70.6545L68.4405 53.6175L52.29 57.051L60.5655 73.3815Z"
        fill={primaryColor}
      />
      <path
        d="M117.954 55.4895L135.05 46.026L129.42 28.008L111.29 37.5345L117.954 55.4895Z"
        fill={primaryColor}
      />
      <path
        d="M34.4023 60.876L89.0368 49.2255L150.601 16.875L91.2778 34.3575L34.4023 60.876Z"
        fill="#FFC727"
      />
      <path
        d="M52.29 57.051L110.336 28.746L123.386 24.8985L68.4405 53.6175L52.29 57.051Z"
        fill={primaryColor}
      />
      <path
        d="M111.29 37.5345L129.42 28.008L72.18 43.263L57.4561 50.13L111.29 37.5345Z"
        fill={primaryColor}
      />
      <path
        d="M74.8171 44.4645C74.8171 44.4645 64.5211 50.742 63.2566 59.481C61.9921 68.22 65.0431 75.0645 64.4581 78.03C63.8731 80.991 57.4561 87.0165 57.4561 87.0165L74.4256 92.9025C74.4256 92.9025 79.1596 90.4185 78.1741 81.9495C77.1931 73.4805 72.1486 65.574 73.0891 58.7475C74.0296 51.921 79.1056 45.711 79.1056 45.711L74.8171 44.4645Z"
        fill={primaryColor}
      />
      <path
        d="M73.3456 63.9945C68.7916 62.0955 65.6416 59.7645 63.5986 57.8745V57.87C65.7766 49.9815 74.8216 44.4645 74.8216 44.4645L79.1146 45.711C79.1146 45.711 74.0386 51.921 73.0981 58.7475C72.8641 60.435 72.9991 62.1855 73.3456 63.9945Z"
        fill={primaryColor}
      />
      <path
        d="M91.5254 35.748C91.5254 35.748 100.314 28.2195 109.098 29.0925C117.882 29.9655 123.579 33.606 126.594 33.75C129.609 33.894 136.998 29.1105 136.998 29.1105L138.64 46.998C138.64 46.998 135.094 50.994 127.107 48.0105C119.119 45.027 112.657 38.232 105.804 37.5075C98.9504 36.783 91.7009 40.14 91.7009 40.14L91.5254 35.748Z"
        fill={primaryColor}
      />
      <path
        d="M119.389 44.0108C114.669 41.0948 110.322 37.9808 105.808 37.5038C98.9549 36.7793 91.7054 40.1408 91.7054 40.1408L91.5254 35.7488C91.5254 35.7488 100.314 28.2248 109.098 29.0933C110.974 29.2778 112.707 29.5928 114.3 29.9708C116.262 33.5348 118.552 38.6108 119.389 44.0108Z"
        fill={primaryColor}
      />
      <path
        d="M119.39 44.01C120.231 44.5005 121.086 44.9685 121.946 45.4275C122.805 45.882 123.66 46.3455 124.542 46.755C125.415 47.178 126.302 47.583 127.206 47.9385C128.111 48.2895 129.029 48.6135 129.978 48.8385C129.011 48.699 128.066 48.4245 127.143 48.1005C126.221 47.7765 125.33 47.3715 124.443 46.9575C123.566 46.5255 122.702 46.071 121.86 45.5805C121.014 45.09 120.186 44.568 119.39 44.01Z"
        fill="black"
      />
      <path
        d="M118.188 31.068C119.272 31.3155 120.307 31.7205 121.351 32.0895C122.395 32.463 123.43 32.8545 124.483 33.174C125.01 33.3405 125.536 33.498 126.076 33.588C126.607 33.687 127.152 33.642 127.692 33.543C128.232 33.4485 128.763 33.2955 129.285 33.12C129.811 32.949 130.324 32.7465 130.828 32.517C129.852 33.039 128.817 33.471 127.723 33.714C127.179 33.8355 126.603 33.885 126.04 33.7905C125.482 33.7005 124.947 33.552 124.416 33.39C123.358 33.048 122.319 32.6565 121.288 32.2515L119.745 31.6395C119.232 31.428 118.719 31.221 118.188 31.068Z"
        fill="black"
      />
      <path
        d="M109.589 29.0745C110.259 31.6935 99.3424 39.0015 90.5269 38.934C90.5269 38.934 94.4059 31.2435 100.184 28.818C105.962 26.3925 109.301 27.936 109.589 29.0745Z"
        fill="black"
      />
      <path
        d="M90.5267 38.934L90.2072 38.079L89.8382 37.0845L89.6987 36.7155C91.0937 26.3205 98.0462 19.5255 98.6852 19.296C99.3242 19.0665 103.712 20.592 106.169 22.8555C108.626 25.1145 109.989 29.862 109.584 29.079C109.179 28.296 106.029 26.991 101.565 28.836C97.1147 30.672 91.1117 37.377 90.5267 38.934Z"
        fill={primaryColor}
      />
      <path
        d="M90.2118 38.079L89.8428 37.0845C90.2523 35.1225 91.0668 33.2415 92.2278 31.617C92.2593 31.5765 92.3178 31.617 92.3043 31.662C91.8408 32.742 91.4268 33.831 91.0623 34.929C92.3718 32.7735 94.0908 30.8205 95.7783 29.0385C95.8503 28.962 95.9808 29.0655 95.9088 29.1465C93.4833 31.815 91.9398 34.974 90.2118 38.079Z"
        fill="black"
      />
      <path
        d="M111.528 49.878C109.588 52.4115 97.4247 48.0466 91.0527 39.8296C91.0527 39.8296 98.4507 37.2646 104.913 40.8511C111.379 44.4376 112.369 48.78 111.528 49.878Z"
        fill="black"
      />
      <path
        d="M91.0575 39.8295L89.9595 36.8955C100.611 30.6045 111.982 32.094 112.662 32.517C113.341 32.94 115.128 38.1195 114.822 42.048C114.516 45.9765 111.114 50.697 111.546 49.7565C111.978 48.8115 110.889 44.937 105.925 42.147C100.962 39.357 92.925 39.2355 91.0575 39.8295Z"
        fill={primaryColor}
      />
      <path
        d="M90.657 38.7585L90.396 38.0655C93.996 36.756 98.0775 36.5355 101.817 36.9315C101.929 36.945 101.92 37.134 101.808 37.1295C99.7155 37.0665 97.587 37.2105 95.517 37.5435C93.8385 37.818 92.2545 38.2725 90.657 38.7585Z"
        fill="black"
      />
      <path
        d="M114.097 45.1035C114.241 44.4465 114.403 43.803 114.543 43.155C114.682 42.507 114.795 41.859 114.853 41.1885C114.912 41.5215 114.916 41.8635 114.903 42.201C114.885 42.5385 114.831 42.8715 114.763 43.2045C114.615 43.857 114.412 44.5005 114.097 45.1035Z"
        fill="black"
      />
      <path
        d="M65.1465 45.7245C66.3615 48.141 79.3935 46.4715 85.995 40.6305C85.995 40.6305 78.021 37.3815 72.072 39.3525C66.123 41.3235 64.62 44.6805 65.1465 45.7245Z"
        fill="black"
      />
      <path
        d="M63.6346 38.79C63.9991 35.469 66.3031 31.4325 66.9376 31.1895C67.5721 30.942 77.2786 31.4955 85.1581 38.4165L85.3426 38.9025L85.7881 40.0815L85.9951 40.6305C84.5371 39.843 75.6001 38.7315 71.0281 40.2705C66.4561 41.814 64.9396 44.8695 65.1466 45.7245C65.3581 46.584 63.2656 42.111 63.6346 38.79Z"
        fill={primaryColor}
      />
      <path
        d="M74.6282 35.3565C77.1437 35.6175 79.5692 36.261 81.9002 37.242C83.0342 37.719 84.2177 38.2635 85.3427 38.9025L85.7882 40.0815C84.5147 39.285 83.2277 38.52 81.8192 37.908C79.4972 36.9 77.0492 36.1935 74.5742 35.6805C74.3672 35.6355 74.4212 35.3385 74.6282 35.3565Z"
        fill="black"
      />
      <path
        d="M77.319 62.6805C80.4465 63.315 86.7825 52.0335 86.184 41.652C86.184 41.652 78.921 44.5815 76.41 51.534C73.8945 58.482 75.9645 62.406 77.319 62.6805Z"
        fill="black"
      />
      <path
        d="M65.0972 50.3415C65.3312 49.572 72.9272 40.9815 85.0862 38.7225L86.1842 41.6565C84.3842 42.435 78.4082 47.808 76.5002 53.172C74.5922 58.536 76.3202 62.172 77.2652 62.604C78.2102 63.0315 72.5402 61.7085 69.7322 58.95C66.9242 56.1825 64.8632 51.1065 65.0972 50.3415Z"
        fill={primaryColor}
      />
      <path
        d="M75.8249 48.8385C76.6124 46.5795 78.1199 44.9325 79.9559 43.4385C81.2519 42.39 82.6964 41.409 84.2129 40.599C83.2139 40.9365 82.2194 41.274 81.2564 41.724C79.5104 42.5475 78.0344 43.6365 76.5134 44.802C76.4054 44.883 76.3019 44.73 76.3694 44.64C78.3404 42.021 82.1789 40.446 85.4414 39.672L85.7924 40.608C84.1544 41.4765 82.5299 42.327 81.0134 43.443C79.1144 44.8335 76.9139 46.665 75.9914 48.9015C75.9554 48.996 75.7889 48.9375 75.8249 48.8385Z"
        fill="black"
      />
      <path
        d="M83.7992 39.699C83.5922 39.096 82.9622 36.837 83.6597 36.1845C84.3527 35.5365 85.9862 35.5095 86.3687 35.3655H86.3732C86.7512 35.2215 87.9977 34.1685 88.9517 34.2045C89.9057 34.236 90.9137 36.351 91.1522 36.945C91.3907 37.5345 92.2097 39.879 91.5437 40.4325C90.8732 40.986 88.8932 41.1615 88.5827 41.274C88.2767 41.391 86.6657 42.561 85.7972 42.5835C84.9287 42.606 84.0062 40.302 83.7992 39.699Z"
        fill={primaryColor}
      />
      <path
        d="M55.8945 109.917L106.088 121.972L169.106 115.556L111.848 105.507L55.8945 109.917Z"
        fill="#FFC727"
      />
      <path
        opacity="0.3"
        d="M55.8945 109.917L106.088 121.972L169.106 115.556L111.848 105.507L55.8945 109.917Z"
        fill="white"
      />
      <path
        d="M81.5271 198.445C82.4631 198.747 109.184 198.463 110.197 197.811C110.584 197.563 110.768 193.671 110.858 188.959C110.876 187.942 110.894 186.889 110.899 185.823C110.962 178.893 110.867 171.54 110.867 171.54L92.9931 171.675L93.5151 185.953L93.6276 189.085C93.6276 189.085 83.4441 193.77 82.4136 194.607C81.3876 195.448 80.5911 198.139 81.5271 198.445Z"
        fill="#FFDEBF"
      />
      <path
        d="M81.5265 198.445C82.4625 198.747 109.179 198.463 110.192 197.815C110.579 197.563 110.768 193.675 110.853 188.964C110.876 187.947 110.894 186.894 110.898 185.827C110.907 184.729 110.912 183.618 110.916 182.529H93.3885L93.5145 185.958L93.6315 189.094C93.6315 189.094 83.448 193.783 82.4175 194.616C81.387 195.448 80.5905 198.139 81.5265 198.445Z"
        fill="white"
      />
      <path
        d="M81.4455 198.482C82.386 198.788 109.255 198.504 110.272 197.843C110.745 197.541 110.92 191.821 110.979 185.787L93.501 185.922L93.6135 189.072C93.6135 189.072 83.376 193.784 82.3365 194.625C81.306 195.471 80.505 198.18 81.4455 198.482Z"
        fill="#FFC727"
      />
      <path
        d="M81.8189 197.406C86.3234 197.248 104.499 197.037 108.963 197.221C108.999 197.221 108.999 197.248 108.963 197.248C104.503 197.505 86.3234 197.568 81.8189 197.478C81.7244 197.478 81.7244 197.406 81.8189 197.406Z"
        fill="black"
      />
      <path
        d="M92.97 188.082C94.7385 187.731 96.9075 187.983 98.2755 189.229C98.3295 189.279 98.2575 189.351 98.2035 189.333C96.4485 188.802 94.8105 188.464 92.979 188.302C92.853 188.293 92.844 188.109 92.97 188.082Z"
        fill="black"
      />
      <path
        d="M91.7009 188.87C93.4694 188.518 95.6384 188.771 97.0064 190.017C97.0604 190.067 96.9884 190.139 96.9344 190.121C95.1794 189.59 93.5414 189.252 91.7099 189.09C91.5794 189.081 91.5704 188.892 91.7009 188.87Z"
        fill="black"
      />
      <path
        d="M90.4275 189.652C92.196 189.301 94.365 189.553 95.733 190.8C95.787 190.849 95.715 190.922 95.661 190.904C93.906 190.372 92.268 190.035 90.4365 189.873C90.3105 189.864 90.3015 189.675 90.4275 189.652Z"
        fill="black"
      />
      <path
        d="M89.1582 190.436C90.9267 190.085 93.0957 190.337 94.4637 191.583C94.5177 191.633 94.4457 191.705 94.3917 191.687C92.6367 191.156 90.9987 190.818 89.1672 190.656C89.0367 190.647 89.0322 190.463 89.1582 190.436Z"
        fill="black"
      />
      <path
        d="M90.4723 186.534C91.7368 187.497 93.3703 187.875 94.8418 188.401C94.9948 188.455 95.1118 188.311 95.1163 188.176C95.1433 188.172 95.1703 188.149 95.1568 188.113C94.6573 186.637 93.5953 185.076 92.3848 184.081C91.6378 183.469 90.3373 183.051 89.6488 184.018C89.0053 184.932 89.7343 185.971 90.4723 186.534ZM90.0088 185.112C89.6758 183.172 91.7728 184.171 92.3083 184.644C92.6503 184.95 92.9608 185.301 93.2578 185.647C93.8788 186.376 94.3873 187.182 94.9273 187.965C94.2208 187.663 93.4963 187.42 92.7808 187.146C91.9258 186.822 90.1933 186.183 90.0088 185.112Z"
        fill="black"
      />
      <path
        d="M101.047 185.351C100.606 184.248 99.2428 184.352 98.3743 184.77C96.9658 185.454 95.5618 186.718 94.7338 188.037C94.7113 188.068 94.7338 188.095 94.7608 188.109C94.7338 188.239 94.8148 188.41 94.9768 188.392C96.5293 188.226 98.2078 188.239 99.6613 187.601C100.507 187.232 101.466 186.395 101.047 185.351ZM97.2763 187.663C96.5158 187.762 95.7553 187.825 94.9948 187.956C95.7058 187.321 96.3898 186.656 97.1638 186.093C97.5328 185.823 97.9198 185.553 98.3248 185.337C98.9548 185 101.227 184.523 100.449 186.332C100.017 187.33 98.1808 187.542 97.2763 187.663Z"
        fill="black"
      />
      <path
        d="M116.244 95.04C116.244 95.04 111.033 138.933 110.92 139.527C110.902 139.603 112.401 179.964 112.401 179.964H92.9113C92.9113 179.964 92.3848 145.399 93.1093 138.456C94.0318 129.604 99.8368 95.04 99.8368 95.04H116.244Z"
        fill="black"
      />
      <path
        d="M111.28 175.959C108.288 175.896 109.147 175.873 106.15 175.842C104.683 175.828 95.0532 175.743 93.6852 175.972C93.6537 175.977 93.6537 176.026 93.6852 176.035C95.0532 176.26 104.683 176.179 106.15 176.166C109.147 176.139 108.283 176.112 111.28 176.049C111.334 176.044 111.334 175.959 111.28 175.959Z"
        fill={primaryColor}
      />
      <path
        d="M108.347 135.931C108.621 133.452 108.977 130.977 109.301 128.506C109.958 123.525 110.615 118.543 111.285 113.562C112.045 107.914 112.855 102.276 113.656 96.6375C113.665 96.57 113.773 96.57 113.764 96.642C113.161 101.677 112.554 106.713 111.933 111.744C111.317 116.73 110.655 121.711 110.007 126.693C109.364 131.629 108.509 136.588 108.536 141.579C108.549 144.09 108.657 146.601 108.725 149.112C108.792 151.623 108.864 154.138 108.932 156.649C109.085 162.337 109.301 168.03 109.242 173.722C109.242 173.794 109.134 173.79 109.13 173.718C108.788 168.646 108.675 163.561 108.509 158.485C108.342 153.463 108.162 148.437 108.054 143.41C108.005 140.904 108.072 138.42 108.347 135.931Z"
        fill={primaryColor}
      />
      <path
        d="M128.43 197.545C129.375 197.271 151.34 182.052 151.812 180.94C151.992 180.522 149.963 177.192 147.398 173.241C146.844 172.386 146.268 171.508 145.674 170.622C141.84 164.848 137.637 158.814 137.637 158.814L122.913 168.952L131.355 180.477L133.205 183.01C133.205 183.01 127.4 192.6 127.017 193.869C126.635 195.142 127.485 197.82 128.43 197.545Z"
        fill="#FFDEBF"
      />
      <path
        d="M128.43 197.545C129.375 197.271 151.335 182.052 151.812 180.945C151.992 180.522 149.963 177.192 147.393 173.245C146.844 172.39 146.264 171.513 145.67 170.626C145.062 169.713 144.441 168.79 143.834 167.886L129.321 177.714L131.346 180.481L133.2 183.01C133.2 183.01 127.395 192.604 127.013 193.873C126.635 195.142 127.485 197.82 128.43 197.545Z"
        fill="white"
      />
      <path
        d="M128.385 197.622C129.334 197.347 151.42 182.043 151.897 180.927C152.118 180.414 149.058 175.576 145.723 170.55L131.328 180.463L133.191 183.01C133.191 183.01 127.354 192.654 126.967 193.932C126.58 195.21 127.435 197.901 128.385 197.622Z"
        fill="#FFC727"
      />
      <path
        d="M128.088 196.52C131.728 193.865 146.655 183.492 150.457 181.143C150.489 181.125 150.502 181.143 150.475 181.165C146.925 183.879 131.913 194.126 128.133 196.578C128.052 196.632 128.011 196.578 128.088 196.52Z"
        fill="black"
      />
      <path
        d="M132.092 182.551C133.361 181.269 135.296 180.261 137.132 180.526C137.204 180.535 137.186 180.639 137.128 180.657C135.377 181.201 133.834 181.84 132.227 182.736C132.115 182.794 132.002 182.641 132.092 182.551Z"
        fill="black"
      />
      <path
        d="M131.481 183.91C132.75 182.628 134.685 181.62 136.521 181.885C136.593 181.894 136.575 181.998 136.516 182.016C134.766 182.56 133.222 183.199 131.616 184.095C131.503 184.154 131.391 184.005 131.481 183.91Z"
        fill="black"
      />
      <path
        d="M130.869 185.274C132.138 183.991 134.073 182.983 135.909 183.249C135.981 183.258 135.963 183.361 135.904 183.379C134.154 183.924 132.61 184.563 131.004 185.458C130.891 185.517 130.779 185.364 130.869 185.274Z"
        fill="black"
      />
      <path
        d="M130.256 186.637C131.525 185.355 133.46 184.347 135.296 184.612C135.368 184.621 135.35 184.725 135.292 184.743C133.541 185.287 131.998 185.926 130.391 186.822C130.279 186.88 130.166 186.727 130.256 186.637Z"
        fill="black"
      />
      <path
        d="M129.159 182.668C130.743 182.754 132.313 182.155 133.825 181.764C133.983 181.723 134.001 181.539 133.929 181.422C133.951 181.399 133.956 181.368 133.929 181.345C132.687 180.405 130.932 179.707 129.37 179.563C128.407 179.473 127.098 179.856 127.071 181.044C127.044 182.164 128.236 182.614 129.159 182.668ZM127.975 181.75C126.612 180.328 128.907 179.982 129.613 180.072C130.068 180.13 130.522 180.247 130.963 180.373C131.886 180.63 132.759 181.012 133.645 181.354C132.889 181.498 132.156 181.71 131.409 181.881C130.522 182.088 128.731 182.533 127.975 181.75Z"
        fill="black"
      />
      <path
        d="M137.25 175.756C136.269 175.09 135.198 175.941 134.712 176.778C133.929 178.132 133.479 179.968 133.528 181.525C133.528 181.566 133.56 181.575 133.591 181.57C133.641 181.696 133.803 181.786 133.929 181.683C135.121 180.675 136.516 179.743 137.367 178.398C137.857 177.615 138.181 176.386 137.25 175.756ZM135.423 179.784C134.847 180.292 134.253 180.774 133.699 181.305C133.933 180.378 134.122 179.451 134.451 178.546C134.608 178.114 134.775 177.678 134.986 177.273C135.319 176.643 136.935 174.969 137.304 176.904C137.506 177.975 136.107 179.176 135.423 179.784Z"
        fill="black"
      />
      <path
        d="M99.8325 95.04C99.8325 95.04 102.866 104.395 106.299 109.111C106.299 109.111 107.195 143.698 108.594 147.672C110.912 154.255 125.919 176.944 125.919 176.944L142.425 165.546C142.425 165.546 128.164 144.477 127.264 142.087C126.666 140.499 124.92 113.085 125.172 112.396C128.2 104.098 123.637 95.04 123.637 95.04H99.8325Z"
        fill="black"
      />
      <path
        d="M138.902 162.067C136.4 163.714 137.097 163.206 134.613 164.884C133.398 165.703 125.424 171.103 124.425 172.071C124.403 172.093 124.434 172.134 124.461 172.12C125.717 171.531 133.596 165.991 134.793 165.145C137.241 163.422 136.521 163.89 138.951 162.139C138.996 162.108 138.951 162.04 138.902 162.067Z"
        fill={primaryColor}
      />
      <path
        d="M123.084 111.397C123.332 110.317 123.602 109.246 123.764 108.148C123.93 107.041 123.966 105.921 123.903 104.805C123.773 102.546 123.273 100.314 122.684 98.1315C122.535 97.587 122.382 97.0425 122.22 96.498C122.193 96.399 122.342 96.363 122.373 96.4575C123.035 98.5995 123.714 100.741 124.052 102.964C124.38 105.12 124.326 107.262 123.885 109.399C123.435 111.586 122.801 113.715 122.882 115.969C122.927 117.139 124.317 138.87 124.317 139.995C124.317 141.102 124.367 142.218 124.758 143.266C125.136 144.279 125.735 145.197 126.297 146.115C126.891 147.087 127.494 148.054 128.097 149.017C130.478 152.82 132.917 156.591 135.455 160.29C135.774 160.758 136.098 161.226 136.422 161.694C136.454 161.743 136.377 161.784 136.341 161.739C133.677 158.063 131.103 154.332 128.646 150.516C127.44 148.644 126.212 146.767 125.114 144.828C124.596 143.914 124.2 142.951 124.061 141.903C123.921 140.854 122.45 115.686 122.54 114.556C122.625 113.494 122.846 112.441 123.084 111.397Z"
        fill={primaryColor}
      />
      <path
        d="M115.551 98.217C115.961 99.9045 115.902 102.006 117.099 103.392C117.693 104.076 118.558 104.422 119.426 104.602C120.425 104.809 121.437 104.832 122.454 104.769C122.499 104.764 122.5 104.832 122.464 104.841C120.655 105.417 118.143 105.322 116.775 103.828C116.145 103.144 115.866 102.24 115.731 101.34C115.578 100.323 115.488 99.252 115.479 98.2215C115.479 98.181 115.542 98.172 115.551 98.217Z"
        fill={primaryColor}
      />
      <path
        d="M106.183 109.174C106.196 109.008 106.43 109.021 106.444 109.179C106.516 109.944 106.502 110.713 106.525 111.483C106.547 112.207 106.561 112.936 106.583 113.661C106.624 115.155 106.655 116.649 106.691 118.143C106.759 121.131 106.849 124.114 106.97 127.098C107.096 130.081 107.231 133.065 107.38 136.048C107.456 137.538 107.546 139.027 107.632 140.517C107.713 141.952 107.803 143.392 108.077 144.805C108.635 147.694 109.774 150.538 111.313 153.072C111.349 153.13 111.259 153.175 111.218 153.121C109.603 150.957 108.473 148.563 107.843 145.957C107.168 143.167 107.096 140.274 106.939 137.421C106.597 131.395 106.376 125.365 106.228 119.331C106.187 117.639 106.147 115.942 106.142 114.246C106.138 113.418 106.138 112.59 106.142 111.766C106.142 110.911 106.111 110.038 106.183 109.174Z"
        fill={primaryColor}
      />
      <path
        d="M103.136 107.716C105.12 108.369 107.037 109.291 108.869 110.263C108.941 110.299 108.891 110.407 108.815 110.376C106.884 109.584 104.913 108.828 103.028 107.937C102.884 107.865 102.983 107.667 103.136 107.716Z"
        fill={primaryColor}
      />
      <path
        d="M102.555 95.0985C102.56 95.0355 102.677 95.022 102.677 95.0895C102.663 97.2765 102.807 99.2025 103.001 101.245C103.091 102.195 103.892 107.437 105.615 107.055C105.903 106.992 106.052 106.717 106.097 106.303C106.151 105.804 105.953 105.192 105.867 104.697C105.674 103.599 105.521 102.496 105.422 101.389C105.237 99.3195 105.228 97.2495 105.494 95.184C105.503 95.1165 105.606 95.121 105.606 95.1885C105.602 98.055 105.683 100.912 106.133 103.752C106.349 105.115 107.069 107.172 105.575 107.379C104.049 107.595 103.064 104.152 102.879 103.212C102.357 100.588 102.335 97.7535 102.555 95.0985Z"
        fill={primaryColor}
      />
      <path
        d="M105.571 107.194C105.728 107.545 105.854 107.914 105.958 108.283C106.039 108.571 106.151 108.877 106.12 109.179C106.115 109.237 106.034 109.242 105.998 109.201C105.796 108.958 105.71 108.621 105.598 108.333C105.467 107.995 105.328 107.662 105.206 107.325C105.125 107.095 105.472 106.978 105.571 107.194Z"
        fill={primaryColor}
      />
      <path
        d="M114.908 50.697C115.425 50.8455 117.756 50.922 118.971 53.2395C120.119 55.431 119.723 61.506 119.835 62.856C119.948 64.2105 121.631 64.665 121.806 66.2445C121.955 67.6035 120.933 67.9365 120.69 68.8815C120.501 69.6105 121.082 70.839 120.24 71.8335C119.475 72.738 118.422 72.3645 117.72 72.576C117.018 72.792 116.384 74.2455 115.11 74.4705C113.837 74.6955 112.932 73.431 112.289 73.341C111.645 73.251 110.583 75.1095 108.513 74.619C106.443 74.1285 106.106 72.261 105.291 71.784C104.477 71.3025 102.213 71.577 101.385 70.3485C100.557 69.1155 100.602 67.644 100.238 67.0455C99.8688 66.447 98.9238 66.3885 98.5548 65.0745C98.1858 63.7605 99.4458 63.153 99.7698 62.109C99.9948 61.3845 99.4368 60.597 100.071 59.535C100.944 58.068 102.807 58.6935 103.779 57.1995C104.54 56.0295 106.551 50.7375 110.061 49.887C112.473 49.293 114.908 50.697 114.908 50.697Z"
        fill="black"
      />
      <path
        d="M119.817 62.532C119.876 62.838 120.083 63.0855 120.272 63.3195L120.866 64.0125C121.257 64.467 121.658 64.935 121.878 65.4705C122.112 65.9925 122.112 66.609 121.838 67.095C121.703 67.338 121.505 67.5495 121.289 67.7565C121.077 67.9635 120.83 68.1615 120.65 68.4765C120.474 68.8185 120.537 69.183 120.587 69.4755C120.641 69.7815 120.708 70.074 120.744 70.3665C120.83 70.947 120.785 71.541 120.443 72C120.281 72.225 120.056 72.4005 119.781 72.477C119.511 72.558 119.214 72.558 118.917 72.531C118.62 72.5085 118.319 72.4545 118.017 72.4095C117.72 72.3735 117.392 72.333 117.113 72.477C117.401 72.369 117.707 72.441 117.999 72.4995C118.292 72.567 118.589 72.648 118.895 72.6975C119.201 72.7425 119.52 72.7605 119.84 72.684C120.159 72.612 120.452 72.414 120.654 72.1575C121.091 71.649 121.136 70.9245 121.059 70.3215C121.023 70.011 120.96 69.7095 120.915 69.417C120.87 69.12 120.843 68.841 120.96 68.634C121.212 68.184 121.82 67.8375 122.117 67.2435C122.427 66.663 122.423 65.925 122.121 65.358C121.842 64.782 121.41 64.332 120.987 63.8955L120.339 63.2565C120.137 63.0405 119.907 62.8245 119.817 62.532Z"
        fill="black"
      />
      <path
        d="M106.529 52.5015C105.818 53.334 105.309 54.3105 104.711 55.2105C104.414 55.6605 104.13 56.124 103.802 56.547C103.635 56.7495 103.469 56.9655 103.275 57.1185C103.23 57.1635 103.181 57.195 103.131 57.2175C103.086 57.2445 103.041 57.2715 102.974 57.2895C102.852 57.3345 102.722 57.366 102.596 57.402C102.083 57.546 101.538 57.6585 101.016 57.8655C100.499 58.0635 99.9768 58.3785 99.6573 58.869C99.4998 59.112 99.3828 59.391 99.3603 59.6835C99.3378 59.976 99.4053 60.2595 99.4863 60.5205C99.6663 61.038 99.8283 61.551 99.7608 62.1C99.9093 61.5645 99.7743 60.993 99.6483 60.4755C99.5853 60.2145 99.5403 59.9535 99.5763 59.706C99.6078 59.4585 99.7203 59.2245 99.8733 59.022C100.184 58.617 100.629 58.3335 101.129 58.158C101.624 57.9735 102.15 57.8745 102.686 57.735C102.821 57.699 102.951 57.6585 103.086 57.609C103.212 57.564 103.388 57.4695 103.482 57.375C103.712 57.1815 103.878 56.961 104.049 56.7405C104.378 56.295 104.67 55.8315 104.936 55.3545L105.723 53.9235C105.975 53.4375 106.223 52.9515 106.529 52.5015Z"
        fill="black"
      />
      <path
        d="M99.7695 66.6C99.954 66.942 99.9225 67.3515 99.954 67.734C99.9765 68.121 100.004 68.5125 100.044 68.904C100.085 69.2955 100.157 69.687 100.278 70.074C100.404 70.4565 100.589 70.8435 100.904 71.1405C101.565 71.721 102.443 71.7975 103.217 71.775C103.613 71.7615 104 71.73 104.382 71.7255C104.765 71.712 105.152 71.7345 105.512 71.901C105.192 71.6625 104.778 71.5995 104.391 71.5545C103.995 71.523 103.608 71.5275 103.221 71.5095C102.465 71.478 101.669 71.37 101.142 70.8885C100.886 70.6545 100.719 70.317 100.593 69.966C100.458 69.615 100.386 69.237 100.31 68.8635C100.233 68.4855 100.184 68.0985 100.125 67.716C100.089 67.5225 100.053 67.329 100.008 67.14C99.954 66.9465 99.918 66.7395 99.7695 66.6Z"
        fill="black"
      />
      <path
        d="M112.208 71.9055C109.121 73.899 94.9369 78.831 90.0049 76.014C84.9784 73.143 80.5864 58.878 79.6324 57.6135C77.0224 54.144 89.2399 50.049 90.2119 52.4115C91.8409 56.358 95.1979 66.852 96.9754 67.167C100.706 67.8285 104.171 67.518 110.052 67.752C114.152 67.914 115.614 69.7095 112.208 71.9055Z"
        fill="#FFDEBF"
      />
      <path
        d="M91.3371 55.035C91.3371 55.035 95.6436 66.2625 96.7281 66.6315C98.5281 67.248 108.46 67.4145 112.019 67.6575C115.579 67.9005 118.841 71.2305 110.251 73.944C101.656 76.6575 94.4556 77.931 89.9376 76.662C87.1206 75.87 79.9341 63.117 79.9341 63.117L91.3371 55.035Z"
        fill="black"
      />
      <path
        opacity="0.1"
        d="M115.687 70.3619C115.48 71.4689 113.986 72.7604 110.251 73.9394C101.66 76.6575 94.4557 77.9265 89.9422 76.662C89.3797 76.5045 88.6418 75.87 87.8228 74.9519C94.3883 73.8854 110.228 71.3204 115.687 70.3619Z"
        fill="white"
      />
      <path
        d="M86.3467 66.078L86.3872 67.455L85.3927 66.348L84.1462 66.699L84.8122 65.6955L83.9302 64.71L85.2037 65.106L86.2702 63.4995L86.3287 65.4525L87.3772 65.781L86.3467 66.078ZM92.1067 71.7345L91.3642 72.3015L90.2437 71.775L90.5722 72.909L89.6677 73.5975L90.7837 73.467L91.1527 74.421L91.5217 73.3815L92.7817 73.2375L91.8052 72.585L92.1067 71.7345ZM92.2687 58.644L91.3327 58.608L90.8062 57.4875L90.3337 58.572L89.1997 58.527L90.1402 59.1435L89.8162 60.1155L90.7612 59.553L91.8232 60.246L91.4857 59.121L92.2687 58.644ZM93.8527 68.5395L94.0057 67.878L94.8742 67.653L94.1677 67.1715L94.3522 66.3705L93.7852 66.96L92.8627 66.6L93.2992 67.4055L92.7772 68.013L93.6232 67.9275L93.8527 68.5395ZM97.4302 75.7845L97.5832 75.123L98.4517 74.898L97.7452 74.4165L97.9297 73.6155L97.3627 74.205L96.4402 73.845L96.8767 74.6505L96.3547 75.258L97.2007 75.1725L97.4302 75.7845Z"
        fill="white"
      />
      <path
        d="M81.9502 65.241C86.0497 61.758 90.8557 58.7565 91.6612 58.1715C91.6972 58.1445 91.7377 58.212 91.6972 58.239C90.8827 58.77 85.7392 62.8335 81.9907 65.3175C81.9457 65.3445 81.9097 65.277 81.9502 65.241Z"
        fill="black"
      />
      <path
        d="M80.3344 58.9185C81.4639 59.85 90.0139 55.395 90.2794 53.9145C90.3289 53.6355 90.3019 53.1 90.2119 52.4115C90.2164 52.407 90.2164 52.407 90.2164 52.407C90.2164 52.407 90.9724 49.14 92.5654 46.6425C93.9019 44.5455 96.1249 41.58 95.0224 40.824C93.4204 39.7125 90.1579 43.119 88.4074 45.189C87.8944 43.8075 87.3229 42.6645 86.7469 42.12C84.8299 40.3155 75.6904 47.844 76.0639 50.4945C76.4194 53.055 79.2049 57.987 80.3344 58.9185Z"
        fill="#FFDEBF"
      />
      <path
        d="M89.1363 45.495C88.6008 46.7505 87.4263 45.4005 87.4263 45.4005C87.4263 45.4005 88.6503 47.754 87.5928 48.8385C86.5758 49.878 85.2123 48.195 85.1133 48.078C85.1763 48.204 86.2428 50.3955 85.0728 51.3765C83.8533 52.3935 82.7778 50.4675 82.7058 50.3415C82.7283 50.4765 83.0028 52.2945 81.9408 52.8345C80.1183 53.766 79.2948 49.14 77.8953 48.249C77.8953 48.249 76.1178 50.445 76.0548 50.4945C76.0548 50.4945 75.1773 46.1115 76.4823 44.2935C77.1708 43.335 78.1968 43.7895 78.1968 43.7895C78.1968 43.7895 77.7603 42.408 78.6558 41.607C79.1193 41.1975 80.1858 41.571 80.1858 41.571C80.1858 41.571 79.8798 40.4505 80.7258 39.789C81.3963 39.258 82.3638 39.717 82.3638 39.717C82.3638 39.717 82.5708 38.5065 83.4303 38.187C85.1718 37.539 90.2838 42.7995 89.1363 45.495Z"
        fill="#FFDEBF"
      />
      <path
        d="M82.5298 39.7665C82.5118 39.7485 82.5298 39.7215 82.5523 39.735C84.6538 41.0535 86.5618 43.146 87.4978 45.4635C87.5293 45.54 87.4168 45.621 87.3673 45.5445C85.9453 43.344 84.5098 41.5035 82.5298 39.7665Z"
        fill="black"
      />
      <path
        d="M80.1766 41.535C80.1541 41.517 80.1856 41.481 80.2126 41.499C82.3726 42.8715 84.4561 45.288 85.2211 48.0825C85.2481 48.177 85.1761 48.2895 85.1356 48.1815C84.4831 46.3635 81.9676 43.0875 80.1766 41.535Z"
        fill="black"
      />
      <path
        d="M82.692 50.5529C81.855 47.8979 80.253 45.783 78.2955 43.8435C78.2685 43.8165 78.309 43.785 78.336 43.7985C79.551 44.487 80.6715 45.8505 81.4545 46.989C82.2015 48.078 82.6605 49.2119 82.7865 50.5214C82.791 50.5709 82.71 50.6069 82.692 50.5529Z"
        fill="black"
      />
      <path
        d="M87.4714 45.4095C87.5074 45.4995 87.3364 45.4545 87.3679 45.5445C87.5119 45.9315 88.1644 48.3435 87.4129 48.825C86.8099 49.2075 85.8784 48.663 85.5994 48.312L84.9064 47.43L85.2529 48.4965C85.4014 48.9645 85.4959 49.4775 85.4869 49.9635C85.4779 50.4495 85.3429 50.931 85.0009 51.2145C84.6544 51.516 84.2044 51.5745 83.8264 51.318C83.4439 51.084 83.1289 50.6565 82.9039 50.238L82.2829 49.0635L82.4854 50.3685C82.5394 50.724 82.5529 51.1065 82.5169 51.4665C82.4764 51.8265 82.3729 52.182 82.1614 52.4295C81.9544 52.6725 81.6124 52.7985 81.3199 52.713C81.0094 52.6275 80.7349 52.353 80.4964 52.0695C80.0194 51.4845 79.6594 50.7915 79.2679 50.121C79.0744 49.7835 78.8809 49.446 78.6694 49.113C78.4579 48.789 78.2329 48.447 77.8999 48.2355C78.2104 48.4785 78.3859 48.834 78.5749 49.167C78.7549 49.509 78.9214 49.86 79.0879 50.211C79.4209 50.913 79.7674 51.615 80.2399 52.2675C80.4874 52.578 80.7619 52.911 81.2029 53.0685C81.6619 53.226 82.1659 53.037 82.4629 52.695C82.7689 52.3485 82.8814 51.9165 82.9354 51.516C82.9849 51.102 82.9759 50.706 82.9219 50.292L82.5034 50.4225C82.7644 50.922 83.0794 51.3765 83.5789 51.7095C83.8264 51.8715 84.1504 51.9705 84.4699 51.93C84.7894 51.8895 85.0639 51.7455 85.2934 51.5475C85.7659 51.1335 85.9054 50.508 85.9054 49.9635C85.9054 49.4055 85.7974 48.879 85.6219 48.3525L85.2754 48.5415C85.6399 48.9735 86.6164 49.698 87.6289 49.2255C88.8574 48.4155 87.7144 45.864 87.4714 45.4095Z"
        fill="black"
      />
      <path
        d="M87.4263 45.4005C87.6648 45.576 87.9168 45.729 88.1598 45.81C88.4028 45.891 88.6368 45.855 88.7943 45.711C88.9563 45.576 89.0508 45.315 89.1183 45.054C89.1813 44.784 89.2308 44.5005 89.2713 44.2035C89.3793 44.487 89.4333 44.7885 89.4153 45.0945C89.3973 45.4005 89.3208 45.7425 89.0418 45.999C88.8933 46.116 88.7223 46.188 88.5378 46.2015C88.3533 46.206 88.1778 46.161 88.0383 46.08C87.7503 45.9225 87.5523 45.6705 87.4263 45.4005Z"
        fill="black"
      />
      <path
        d="M102.294 85.779L99.356 95.6655L124.587 96.5835C124.587 96.5835 123.588 77.5755 118.58 70.443C116.073 66.8745 112.604 66.6585 110.12 68.589C109.49 69.0795 102.807 75.618 101.664 78.8625C100.661 81.7245 102.294 85.779 102.294 85.779Z"
        fill="black"
      />
      <path
        d="M113.193 86.805L113.234 88.182L112.239 87.075L110.993 87.426L111.659 86.4225L110.777 85.437L112.05 85.833L113.117 84.2265L113.175 86.1795L114.224 86.508L113.193 86.805ZM109.805 74.7315L108.734 74.97L107.712 73.3005L107.586 75.2265L106.281 75.5145L107.537 75.9285L107.46 77.13L108.365 76.203L109.778 76.671L109.058 75.4965L109.805 74.7315ZM118.953 92.457L118.211 93.024L117.09 92.4975L117.419 93.6315L116.514 94.32L117.63 94.1895L117.999 95.1435L118.368 94.104L119.628 93.96L118.652 93.3075L118.953 92.457ZM104.864 88.0875L104.121 88.6545L103.001 88.128L103.329 89.262L102.425 89.9505L103.541 89.82L103.91 90.774L104.279 89.7345L105.539 89.5905L104.562 88.938L104.864 88.0875ZM119.115 79.3665L118.179 79.3305L117.653 78.21L117.18 79.2945L116.046 79.2495L116.987 79.866L116.663 80.838L117.608 80.2755L118.67 80.9685L118.332 79.8435L119.115 79.3665ZM120.699 89.2665L120.852 88.605L121.721 88.38L121.014 87.8985L121.199 87.0975L120.632 87.687L119.709 87.327L120.146 88.1325L119.624 88.74L120.47 88.6545L120.699 89.2665ZM103.716 82.89L103.869 82.2285L104.738 82.0035L104.031 81.522L104.216 80.721L103.649 81.3105L102.726 80.9505L103.163 81.756L102.641 82.3635L103.487 82.278L103.716 82.89ZM109.112 94.1805L108.684 93.6585L109.04 92.835L108.225 93.1005L107.703 92.4615L107.825 93.267L106.974 93.7755L107.879 93.9195L108.041 94.707L108.486 93.9825L109.112 94.1805Z"
        fill="white"
      />
      <path
        d="M109.692 84.87C108.689 84.906 107.676 84.978 106.691 85.1625C106.2 85.2525 105.714 85.3695 105.228 85.4955C104.985 85.5585 104.747 85.6125 104.499 85.6665C104.247 85.7205 103.982 85.77 103.725 85.761C103.703 85.761 103.703 85.7925 103.725 85.797C103.973 85.8195 104.211 85.842 104.463 85.833C104.702 85.824 104.94 85.788 105.174 85.7475C105.674 85.6575 106.169 85.5495 106.668 85.455C107.676 85.266 108.68 85.077 109.701 84.96C109.746 84.951 109.742 84.87 109.692 84.87Z"
        fill="black"
      />
      <path
        d="M112.109 85.923C111.295 85.7835 110.462 85.6845 109.634 85.6395C109.22 85.617 108.806 85.617 108.392 85.6305C108.194 85.635 107.996 85.644 107.798 85.6575C107.582 85.671 107.362 85.7115 107.146 85.725C107.123 85.725 107.119 85.761 107.146 85.761C107.353 85.7565 107.56 85.788 107.767 85.797C107.974 85.806 108.181 85.815 108.388 85.8195C108.802 85.8375 109.216 85.86 109.63 85.8735C110.458 85.9005 111.286 85.9365 112.114 85.9905C112.15 85.9905 112.15 85.9275 112.109 85.923Z"
        fill="black"
      />
      <path
        d="M116.249 74.61C122.373 81.5625 130.572 89.082 135.387 88.317C139.739 87.624 146.853 82.7775 153.054 77.6835C154.386 76.5855 146.183 66.3345 144.806 67.5585C142.083 69.975 136.44 76.212 134.42 76.8285C133.556 77.094 124.295 71.856 118.188 69.1605C110.781 65.8845 113.81 71.838 116.249 74.61Z"
        fill="#FFDEBF"
      />
      <path
        d="M152.758 77.8905C153.946 77.0895 159.067 72.9405 160.232 71.469C161.398 69.9975 164.449 65.511 163.414 64.503C162.374 63.495 161.38 64.737 161.38 64.737C161.38 64.737 162.37 62.64 161.231 61.722C160.093 60.804 158.603 62.784 158.603 62.784C158.603 62.784 159.463 60.5565 158.261 59.7195C157.06 58.8825 155.899 61.128 155.899 61.128C155.899 61.128 156.776 59.13 155.498 58.8555C153.959 58.527 152.758 62.397 151.345 63.927C151.025 64.2735 144.352 70.506 144.352 70.506L152.758 77.8905Z"
        fill="#FFDEBF"
      />
      <path
        d="M156.007 60.9345C155.116 63.7785 154.229 64.8675 151.993 66.7665C151.948 66.8025 151.993 66.879 152.042 66.843C154.405 65.1825 155.705 63.9765 156.146 60.9705C156.169 60.8265 156.047 60.7995 156.007 60.9345Z"
        fill="black"
      />
      <path
        d="M158.675 62.5545C157.492 65.4255 156.542 66.618 154.346 68.778C154.315 68.8095 154.364 68.8635 154.396 68.8365C156.727 66.897 158.005 65.664 158.81 62.6355C158.846 62.5005 158.729 62.424 158.675 62.5545Z"
        fill="black"
      />
      <path
        d="M161.267 64.845C159.917 67.545 158.936 68.895 156.533 70.7175C156.475 70.7625 156.533 70.848 156.596 70.8075C159.229 69.1875 160.466 67.509 161.344 64.89C161.402 64.7145 161.353 64.674 161.267 64.845Z"
        fill="black"
      />
      <path
        d="M141.994 70.6815C141.994 70.6815 142.912 67.059 143.663 65.5605C144.419 64.0575 149.288 59.4945 150.332 60.489C151.682 61.776 149.392 64.962 148.064 66.3795C148.064 66.3795 151.187 69.3495 150.04 71.9955C148.888 74.637 141.994 70.6815 141.994 70.6815Z"
        fill="#FFDEBF"
      />
      <path
        d="M150.589 60.9615C150.976 63.0225 149.113 64.7685 147.929 66.2355C147.839 66.348 147.898 66.4605 147.997 66.51C149.225 67.842 150.566 70.0785 150.152 71.946C150.139 72 150.215 72.027 150.238 71.973C150.953 70.0335 149.815 67.725 148.379 66.3525C149.617 64.8675 151.408 63.0315 150.616 60.957C150.602 60.948 150.584 60.948 150.589 60.9615Z"
        fill="black"
      />
      <path
        d="M141.066 70.02C141.066 70.02 135.176 76.3515 134.042 76.221C132.152 76.0005 120.92 69.948 117.603 68.6385C114.282 67.329 110.633 67.815 115.646 74.3895C121.302 81.81 127.71 88.4925 134.681 88.8615C138.434 89.0595 150.548 81.495 150.548 81.495L141.066 70.02Z"
        fill="black"
      />
      <path
        d="M137.133 80.739L137.174 82.116L136.179 81.009L134.933 81.36L135.599 80.3565L134.717 79.371L135.99 79.767L137.057 78.1605L137.115 80.1135L138.164 80.442L137.133 80.739ZM143.537 82.0215L142.794 82.5885L141.674 82.062L142.002 83.196L141.098 83.8845L142.214 83.754L142.583 84.708L142.952 83.6685L144.212 83.5245L143.235 82.872L143.537 82.0215ZM131.792 83.367L131.049 83.934L129.929 83.4075L130.257 84.5415L129.353 85.23L130.469 85.0995L130.838 86.0535L131.207 85.014L132.467 84.87L131.49 84.2175L131.792 83.367ZM143.055 73.305L142.119 73.269L141.593 72.1485L141.12 73.233L139.986 73.188L140.931 73.8045L140.607 74.7765L141.552 74.214L142.614 74.907L142.277 73.782L143.055 73.305ZM146.034 81.558L146.187 80.8965L147.056 80.6715L146.349 80.19L146.534 79.389L145.967 79.9785L145.044 79.6185L145.481 80.424L144.959 81.0315L145.805 80.946L146.034 81.558ZM129.375 77.9085L129.528 77.247L130.397 77.022L129.69 76.5405L129.875 75.7395L129.308 76.329L128.385 75.969L128.822 76.7745L128.3 77.382L129.146 77.2965L129.375 77.9085Z"
        fill="white"
      />
      <path
        d="M147.051 82.3365C143.982 77.922 140.099 73.7865 139.473 73.017C139.442 72.981 139.388 73.035 139.419 73.071C140.072 73.7955 144.005 79.038 146.993 82.3995C147.024 82.4355 147.078 82.377 147.051 82.3365Z"
        fill="black"
      />
      <path
        d="M122.769 82.575C122.598 82.3635 116.942 76.0095 116.24 75.2175C116.231 75.204 116.213 75.222 116.222 75.2355C116.861 76.0905 118.211 77.7915 118.224 77.805C118.085 77.7015 117.945 77.598 117.806 77.4945C117.518 77.2785 117.23 77.0625 116.946 76.842C116.928 76.8285 116.91 76.8555 116.924 76.8735C117.621 77.7285 118.355 78.084 118.355 78.084C119.804 79.8165 122.342 82.4805 122.621 82.656C122.846 82.8 122.931 82.7775 122.769 82.575Z"
        fill="black"
      />
      <path
        d="M108.877 67.4999C108.877 67.4999 106.654 72.4409 110.808 73.3004C114.961 74.1599 117.598 68.6429 117.598 68.6429C117.598 68.6429 116.14 67.4549 113.278 67.3784C110.367 67.2974 108.877 67.4999 108.877 67.4999Z"
        fill="#FFDEBF"
      />
      <path
        d="M115.051 68.616C114.921 69.039 112.68 71.703 110.718 71.478C110.079 71.406 110.322 67.896 110.322 67.896L110.281 67.635L109.71 63.954L114.151 61.497L114.79 61.1775C114.79 61.1775 114.88 62.1945 114.979 63.4635C114.984 63.522 114.988 63.5805 114.993 63.6435C115.002 63.7155 115.006 63.783 115.011 63.8505C115.029 64.0395 115.047 64.233 115.056 64.4265C115.065 64.575 115.078 64.7145 115.083 64.872C115.092 65.025 115.096 65.178 115.105 65.331C115.173 66.861 115.101 68.436 115.051 68.616Z"
        fill="#FFDEBF"
      />
      <path
        d="M114.979 63.4635C113.751 66.285 111.366 67.311 110.281 67.635L109.71 63.954L114.151 61.497L114.79 61.1775C114.79 61.1775 114.88 62.1945 114.979 63.4635Z"
        fill="black"
      />
      <path
        d="M105.8 56.7089C104.081 63.018 107.663 64.764 109.026 65.133C110.264 65.4705 114.512 66.4515 116.874 60.3539C119.237 54.2564 116.847 51.4619 114.062 50.5439C111.276 49.6259 107.519 50.3954 105.8 56.7089Z"
        fill="#FFDEBF"
      />
      <path
        d="M107.815 55.8809C107.968 55.8989 108.112 55.8944 108.265 55.8989C108.441 55.9034 108.576 55.9259 108.729 55.8269C108.81 55.7729 108.842 55.6334 108.797 55.5524C108.697 55.3544 108.486 55.2959 108.279 55.2824C108.054 55.2689 107.874 55.3139 107.689 55.4444C107.509 55.5704 107.613 55.8539 107.815 55.8809Z"
        fill="black"
      />
      <path
        d="M112.198 56.997C112.054 56.943 111.928 56.8665 111.793 56.799C111.64 56.7225 111.505 56.6775 111.415 56.52C111.366 56.4345 111.406 56.2995 111.483 56.2455C111.663 56.1195 111.879 56.1645 112.068 56.25C112.275 56.3445 112.41 56.466 112.513 56.6685C112.608 56.8665 112.387 57.069 112.198 56.997Z"
        fill="black"
      />
      <path
        d="M110.804 58.3019C110.813 58.2884 110.831 58.3334 110.826 58.3469C110.696 58.7744 110.615 59.2829 110.966 59.5304C110.975 59.5394 110.97 59.5574 110.957 59.5529C110.498 59.3594 110.61 58.6844 110.804 58.3019Z"
        fill="black"
      />
      <path
        d="M111.308 57.9599C112.015 58.0949 111.686 59.4989 111.034 59.3684C110.395 59.2469 110.719 57.8474 111.308 57.9599Z"
        fill="black"
      />
      <path
        d="M111.569 58.0994C111.672 58.2074 111.758 58.3739 111.902 58.4234C112.068 58.4819 112.23 58.3649 112.374 58.2479C112.388 58.2344 112.397 58.2524 112.397 58.2704C112.338 58.5404 112.172 58.7924 111.875 58.7654C111.605 58.7429 111.47 58.4594 111.465 58.1759C111.465 58.1174 111.524 58.0544 111.569 58.0994Z"
        fill="black"
      />
      <path
        d="M108.296 57.5819C108.296 57.5639 108.256 57.5954 108.256 57.6134C108.17 58.0499 108.004 58.5359 107.576 58.5944C107.563 58.5944 107.558 58.6169 107.576 58.6214C108.067 58.6574 108.287 58.0094 108.296 57.5819Z"
        fill="black"
      />
      <path
        d="M108.009 57.0419C107.32 56.8304 106.951 58.2209 107.59 58.4144C108.216 58.6079 108.585 57.2174 108.009 57.0419Z"
        fill="black"
      />
      <path
        d="M107.694 57.0554C107.563 57.1004 107.419 57.2039 107.289 57.1769C107.136 57.1454 107.064 56.9654 107.001 56.7944C106.996 56.7764 106.983 56.7854 106.974 56.8034C106.897 57.0689 106.911 57.3659 107.154 57.4874C107.374 57.5954 107.604 57.4154 107.739 57.1679C107.766 57.1229 107.748 57.0374 107.694 57.0554Z"
        fill="black"
      />
      <path
        d="M109.687 61.848C109.561 61.929 109.431 62.055 109.273 62.037C109.12 62.0235 108.954 61.92 108.823 61.839C108.81 61.83 108.792 61.8435 108.801 61.857C108.882 62.046 109.102 62.1945 109.314 62.199C109.516 62.199 109.647 62.046 109.728 61.875C109.737 61.8525 109.705 61.839 109.687 61.848Z"
        fill="black"
      />
      <path
        d="M108.189 60.7365C108.189 60.7365 108.36 61.2225 108.715 61.4925C108.846 61.5915 108.999 61.6635 109.179 61.668C109.548 61.686 109.656 61.371 109.678 61.083C109.696 60.8445 109.651 60.624 109.651 60.624C109.651 60.624 109.003 60.9345 108.189 60.7365Z"
        fill="black"
      />
      <path
        d="M108.715 61.488C108.846 61.587 108.999 61.659 109.179 61.6635C109.548 61.6815 109.656 61.3665 109.678 61.0785C109.296 61.0065 108.855 61.1415 108.715 61.488Z"
        fill="#FF9CBD"
      />
      <path
        d="M108.261 59.8455C108.261 59.8455 108.013 60.471 107.937 60.7725C107.928 60.7995 108 60.831 108.103 60.8625C108.108 60.867 108.112 60.867 108.117 60.867C108.634 61.083 109.224 61.029 109.656 60.669C109.683 60.6465 109.651 60.6015 109.62 60.615C109.147 60.813 108.684 60.777 108.202 60.669C108.202 60.579 108.661 59.616 108.616 59.598C108.454 59.544 108.099 59.5755 107.887 59.5845C108.364 58.2705 109.048 57.042 109.507 55.7235C109.521 55.674 109.458 55.647 109.431 55.683C108.621 56.9205 108.04 58.419 107.509 59.7645C107.446 59.94 108.126 59.8635 108.261 59.8455Z"
        fill="black"
      />
      <path
        d="M116.24 60.435C115.2 60.255 115.511 58.059 115.511 58.059C115.511 58.059 113.441 57.537 113.517 54.3915C113.517 54.3915 113.211 55.7865 113.805 57.0825C113.805 57.0825 110.255 55.7685 109.499 52.3215C109.499 52.3215 109.715 54.0315 110.147 54.7335C110.147 54.7335 108.725 53.919 108.297 52.4835C108.297 52.4835 107.208 54.081 106.596 54.4455C106.596 54.4455 107.586 45.855 115.043 50.625C115.043 50.625 118.4 51.4575 118.98 54.729C119.561 57.996 116.24 60.435 116.24 60.435Z"
        fill="black"
      />
      <path
        d="M116.249 62.6805C116.136 62.703 116.033 62.7075 115.938 62.703C115.826 62.703 115.722 62.685 115.632 62.658C115.488 62.6175 115.376 62.55 115.281 62.469C115.196 62.4015 115.128 62.316 115.074 62.2395C114.935 62.0325 114.894 61.8345 114.894 61.8345L115.565 60.1785C115.565 60.1785 117.338 58.4235 118.152 59.094C118.976 59.76 117.392 62.478 116.249 62.6805Z"
        fill="#FFDEBF"
      />
      <path
        d="M117.684 59.859C117.702 59.859 117.702 59.886 117.684 59.8905C116.878 60.057 116.356 60.6824 115.951 61.3529C116.226 61.1144 116.554 61.0199 116.878 61.3529C116.896 61.3709 116.869 61.3979 116.851 61.3889C116.554 61.2674 116.325 61.2809 116.073 61.4879C115.893 61.6364 115.753 61.8389 115.614 62.0189C115.569 62.0774 115.452 62.0234 115.492 61.9469C115.497 61.9424 115.497 61.9379 115.501 61.9289C115.65 60.9704 116.635 59.769 117.684 59.859Z"
        fill="black"
      />
      <path
        d="M116.208 62.3925C116.145 62.55 115.97 62.622 115.817 62.5635C115.659 62.5005 115.587 62.325 115.646 62.172C115.709 62.0145 115.884 61.9425 116.037 62.001C116.195 62.064 116.271 62.2395 116.208 62.3925Z"
        fill="white"
      />
      <path
        d="M116.906 62.055C116.861 62.163 116.739 62.217 116.627 62.1765C116.519 62.1315 116.465 62.01 116.505 61.8975C116.55 61.7895 116.672 61.7355 116.784 61.776C116.892 61.821 116.946 61.947 116.906 62.055Z"
        fill="white"
      />
      <path
        d="M116.173 50.8275C115.529 49.869 116.083 47.1105 117.613 46.161C119.719 44.8515 122.914 47.6415 121.555 50.0805C120.196 52.5195 116.668 51.57 116.173 50.8275Z"
        fill="black"
      />
      <path
        d="M121.123 46.9665C120.538 46.386 119.84 45.9045 119.089 45.684C118.711 45.5805 118.319 45.5625 117.968 45.6795C117.617 45.792 117.302 46.017 117.055 46.314C116.798 46.602 116.605 46.9575 116.429 47.3175C116.245 47.673 116.128 48.0555 116.029 48.4425C115.858 49.2165 115.871 50.058 116.177 50.832C115.727 50.13 115.583 49.23 115.718 48.3885C115.786 47.9655 115.907 47.5515 116.083 47.16C116.263 46.7775 116.461 46.3905 116.753 46.0575C117.041 45.7245 117.419 45.441 117.865 45.324C118.306 45.2025 118.778 45.2475 119.183 45.396C120.002 45.6885 120.65 46.287 121.123 46.9665Z"
        fill="black"
      />
      <path
        d="M63.504 192.141L55.8945 109.917L106.088 121.972V207.045L63.504 192.141Z"
        fill="#FFC727"
      />
      <path
        opacity="0.1"
        d="M63.504 192.141L55.8945 109.917L106.088 121.972V207.045L63.504 192.141Z"
        fill="white"
      />
      <path
        d="M77.2963 196.969L89.4373 201.217L85.2208 116.959L71.3608 113.634L77.2963 196.969Z"
        fill={primaryColor}
      />
      <path
        d="M106.087 121.972V207.045L160.614 197.284L169.105 115.555L106.087 121.972Z"
        fill="#FFC727"
      />
      <path
        d="M127.674 203.179L141.471 200.709L148.108 117.702L131.112 119.425L127.674 203.179Z"
        fill={primaryColor}
      />
    </svg>
  );
}
